"use strict";
// ===========================================================================
// DO NOT EDIT THIS FILE MANUALLY!
//
// The contents have been added automatically.
// See: scripts/generate-apis.ts for more information
// ===========================================================================
Object.defineProperty(exports, "__esModule", { value: true });
exports.airnodeAddressMap = exports.apisData = void 0;
exports.apisData = {
    'shiftmarkets-mock': {
        alias: 'shiftmarkets-mock',
        name: 'ShiftMarkets-Mock',
        providerType: 'rest',
        airnode: '0x4C283936141b6AD8253C599091f86DAdE9dd8fDc',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            ShiftMarkets: [
                [
                    'AERO/USD',
                    'BLAST/USD',
                    'HNT/USD',
                    'ETH/USD',
                    'ADA/USD',
                    'BTC/USD',
                    'USDT/USD',
                    'CRO/USD',
                    'ONDO/USD',
                    'PYUSD/USD',
                    'MERL/USD',
                    'MODE/USD',
                    'CORE/USD',
                    'MNT/USD',
                    'OKB/USD',
                    'BNB/USD',
                    'USDC/USD',
                    'ATOM/USD',
                    'DOGE/USD',
                    'SOL/USD',
                    'BAL/USD',
                    'CRV/USD',
                    'DOT/USD',
                    'RSR/USD',
                    'RUNE/USD',
                    'NEAR/USD',
                    'FIL/USD',
                    'AXS/USD',
                    'GRT/USD',
                    'SHIB/USD',
                    'GLMR/USD',
                    'APE/USD',
                    'LDO/USD',
                    'OP/USD',
                    'GMX/USD',
                    'APT/USD',
                    'ARB/USD',
                    'SUI/USD',
                    'WLD/USD',
                    'FDUSD/USD',
                    'SEI/USD',
                    'TIA/USD',
                    'ORDI/USD',
                    'DYM/USD',
                    'ETHFI/USD',
                    'STX/USD',
                    'KAVA/USD',
                    'MKR/USD',
                    'AVAX/USD',
                    'AAVE/USD',
                    'ROSE/USD',
                    'RIF/USD',
                    'GNO/USD',
                    'ENS/USD',
                    'CVX/USD',
                    'IMX/USD',
                    'ASTR/USD',
                    'RDNT/USD',
                    'WBTC/USD',
                    'RON/USD',
                    'TAO/USD',
                    'LTC/USD',
                    'XRP/USD',
                    'LINK/USD',
                    'SUSHI/USD',
                    'CAKE/USD',
                    'FLOW/USD',
                    'DYDX/USD',
                    'KDA/USD',
                    'PENDLE/USD',
                    'BLUR/USD',
                    'AXL/USD',
                    'ALGO/USD',
                    'BAND/USD',
                    'MASK/USD',
                    'COMP/USD',
                    'UMA/USD',
                    'UNI/USD',
                    'ICP/USD',
                    'W/USD',
                    'GHO/USD',
                    'LUSD/USD',
                    'FRAX/USD',
                    'MANA/USD',
                    'PAXG/USD',
                    'XVS/USD',
                    'AR/USD',
                    'PYTH/USD',
                    'LQTY/USD',
                    'MANTA/USD',
                    'ZIL/USD',
                    'ZRX/USD',
                    'BAT/USD',
                    'ANKR/USD',
                    'SAND/USD',
                    'KSM/USD',
                    'TWT/USD',
                    'JOE/USD',
                    'XLM/USD',
                    'HBAR/USD',
                    'RPL/USD',
                    'ENA/USD',
                    'CHZ/USD',
                    'MOVR/USD',
                    'SNX/USD',
                    'CELO/USD',
                    'API3/USD',
                    'FXS/USD',
                    'WOO/USD',
                    'METIS/USD',
                    'GNS/USD',
                    'STRK/USD',
                    'STG/USD',
                    'TUSD/USD',
                    'TAIKO/USD',
                    'SATS/USD',
                    'DEGEN/USD',
                    'SAFE/USD',
                    'XTZ/USD',
                    'YFI/USD',
                    'OSMO/USD',
                    'USDP/USD',
                    'stETH/USD',
                    'EURe/USD',
                    'FBTC/USD',
                    'AUSD/USD',
                    'EURC/USD',
                    'USDe/USD',
                    'LUMIA/USD',
                    'SCR/USD',
                    'COOK/USD',
                    'cbBTC/USD',
                    'BRETT/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'LBTC/USD',
                    'S/USD',
                    'VELO/USD',
                    'MTL/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'ZK/USD',
                    'ZRO/USD',
                    'POL/USD',
                    'crvUSD/USD',
                    'frxUSD/USD',
                    'HYPE/USD',
                    'VET/USD',
                    'tBTC/USD',
                    'CFX/USD',
                    'DAI/USD',
                    'INJ/USD',
                    'RENDER/USD',
                    'VTHO/USD',
                    'MVL/USD',
                    'VIRTUAL/USD',
                    'DOLA/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'RESOLV/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'USDY/USD',
                    'USD0/USD',
                    'USDD/USD',
                    'EUR/USD',
                    'WELL/USD',
                    'sUSDS/USD',
                    'USDX/USD',
                    'RLUSD/USD',
                    'USDO/USD',
                    'USR/USD',
                    'USDG/USD',
                    'BUSD/USD',
                    'USDa/USD'
                ]
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    shiftmarkets: {
        alias: 'shiftmarkets',
        name: 'ShiftMarkets',
        providerType: 'rest',
        airnode: '0x11A49f063c08f9C9d7A6b13E0529dC132Bd09fF5',
        previousAirnodes: [{ expiryTimestamp: 1749546029, airnodeAddress: '0x1538e800Ae1B34C264E3F44B6Cd82bE033f38E20' }],
        xpub: 'xpub6C1Gvub6qpGMqqfTCvLvsVgxvAXtwHTx3XfGZrAqbzyrJM1kCVh8fSSEjQKfgeUAsXGZh1BUst1xucr72SgncUZERtLL19UWTpstFUYAT3v',
        supportedFeedsInBatches: {
            ShiftMarkets: [
                [
                    'AERO/USD',
                    'BLAST/USD',
                    'HNT/USD',
                    'ETH/USD',
                    'ADA/USD',
                    'BTC/USD',
                    'USDT/USD',
                    'CRO/USD',
                    'ONDO/USD',
                    'PYUSD/USD',
                    'MERL/USD',
                    'MODE/USD',
                    'CORE/USD',
                    'MNT/USD',
                    'OKB/USD',
                    'BNB/USD',
                    'USDC/USD',
                    'ATOM/USD',
                    'DOGE/USD',
                    'SOL/USD',
                    'BAL/USD',
                    'CRV/USD',
                    'DOT/USD',
                    'RSR/USD',
                    'RUNE/USD',
                    'NEAR/USD',
                    'FIL/USD',
                    'AXS/USD',
                    'GRT/USD',
                    'SHIB/USD',
                    'GLMR/USD',
                    'APE/USD',
                    'LDO/USD',
                    'OP/USD',
                    'GMX/USD',
                    'APT/USD',
                    'ARB/USD',
                    'SUI/USD',
                    'WLD/USD',
                    'FDUSD/USD',
                    'SEI/USD',
                    'TIA/USD',
                    'ORDI/USD',
                    'DYM/USD',
                    'ETHFI/USD',
                    'STX/USD',
                    'KAVA/USD',
                    'MKR/USD',
                    'AVAX/USD',
                    'AAVE/USD',
                    'ROSE/USD',
                    'RIF/USD',
                    'GNO/USD',
                    'ENS/USD',
                    'CVX/USD',
                    'IMX/USD',
                    'ASTR/USD',
                    'RDNT/USD',
                    'WBTC/USD',
                    'RON/USD',
                    'TAO/USD',
                    'LTC/USD',
                    'XRP/USD',
                    'LINK/USD',
                    'SUSHI/USD',
                    'CAKE/USD',
                    'FLOW/USD',
                    'DYDX/USD',
                    'KDA/USD',
                    'PENDLE/USD',
                    'BLUR/USD',
                    'AXL/USD',
                    'ALGO/USD',
                    'BAND/USD',
                    'MASK/USD',
                    'COMP/USD',
                    'UMA/USD',
                    'UNI/USD',
                    'ICP/USD',
                    'W/USD',
                    'GHO/USD',
                    'LUSD/USD',
                    'FRAX/USD',
                    'MANA/USD',
                    'PAXG/USD',
                    'XVS/USD',
                    'AR/USD',
                    'PYTH/USD',
                    'LQTY/USD',
                    'MANTA/USD',
                    'ZIL/USD',
                    'ZRX/USD',
                    'BAT/USD',
                    'ANKR/USD',
                    'SAND/USD',
                    'KSM/USD',
                    'TWT/USD',
                    'JOE/USD',
                    'XLM/USD',
                    'HBAR/USD',
                    'RPL/USD',
                    'ENA/USD',
                    'CHZ/USD',
                    'MOVR/USD',
                    'SNX/USD',
                    'CELO/USD',
                    'API3/USD',
                    'FXS/USD',
                    'WOO/USD',
                    'METIS/USD',
                    'GNS/USD',
                    'STRK/USD',
                    'STG/USD',
                    'TUSD/USD',
                    'TAIKO/USD',
                    'SATS/USD',
                    'DEGEN/USD',
                    'SAFE/USD',
                    'XTZ/USD',
                    'YFI/USD',
                    'OSMO/USD',
                    'USDP/USD',
                    'stETH/USD',
                    'EURe/USD',
                    'FBTC/USD',
                    'AUSD/USD',
                    'EURC/USD',
                    'USDe/USD',
                    'LUMIA/USD',
                    'SCR/USD',
                    'COOK/USD',
                    'cbBTC/USD',
                    'BRETT/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'LBTC/USD',
                    'S/USD',
                    'VELO/USD',
                    'MTL/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'ZK/USD',
                    'ZRO/USD',
                    'POL/USD',
                    'crvUSD/USD',
                    'frxUSD/USD',
                    'HYPE/USD',
                    'VET/USD',
                    'tBTC/USD',
                    'CFX/USD',
                    'DAI/USD',
                    'INJ/USD',
                    'RENDER/USD',
                    'VTHO/USD',
                    'MVL/USD',
                    'VIRTUAL/USD',
                    'DOLA/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'RESOLV/USD',
                    'XAUt/USD',
                    'USD1/USD'
                ]
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'eu-central-1', provider: 'aws' },
            { signedApi: false, region: 'ap-south-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.shiftmarkets.com',
        verifiedBaseUrl: 'https://shiftmarkets.com',
        signedApiUrl: 'https://signed-api.shiftmarkets.com',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'nodary-mock': {
        alias: 'nodary-mock',
        name: 'Nodary-Mock',
        providerType: 'rest',
        airnode: '0x241364bbd08701330bdc810bAaA10cF8DF1710E5',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            Nodary: [
                ['cbETH/ETH Exchange Rate'],
                ['rETH/ETH Exchange Rate'],
                ['sfrxETH/frxETH Exchange Rate'],
                ['swETH/ETH Exchange Rate'],
                ['wstETH/stETH Exchange Rate'],
                ['mETH/ETH Exchange Rate'],
                ['MATICx/MATIC Exchange Rate'],
                ['ETHx/ETH Exchange Rate'],
                ['uniETH/ETH Exchange Rate'],
                ['weETH/ETH Exchange Rate'],
                ['STONE/ETH Exchange Rate'],
                ['USDY/USD Exchange Rate'],
                ['rsETH/ETH Exchange Rate'],
                ['rswETH/ETH Exchange Rate'],
                ['apxETH/pxETH Exchange Rate'],
                ['ezETH/ETH Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['sDAI/DAI Exchange Rate'],
                ['sUSDe/USDe Exchange Rate'],
                ['pufETH/stETH Exchange Rate'],
                ['instETH/stETH Exchange Rate'],
                ['AAVE/USD'],
                ['ADA/USD'],
                ['ALGO/USD'],
                ['ANKR/USD'],
                ['APE/USD'],
                ['API3/USD'],
                ['ARB/USD'],
                ['ATOM/USD'],
                ['AVAX/USD'],
                ['AXS/USD'],
                ['BAL/USD'],
                ['BAT/USD'],
                ['BNB/USD'],
                ['BTC/USD'],
                ['CAKE/USD'],
                ['CELO/USD'],
                ['CHZ/USD'],
                ['COMP/USD'],
                ['CRO/USD'],
                ['CRV/USD'],
                ['CVX/USD'],
                ['DAI/USD'],
                ['DOGE/USD'],
                ['DOT/USD'],
                ['DYDX/USD'],
                ['ETH/USD'],
                ['FIL/USD'],
                ['FLOW/USD'],
                ['FXS/USD'],
                ['GLMR/USD'],
                ['GMX/USD'],
                ['GNO/USD'],
                ['GRT/USD'],
                ['HBAR/USD'],
                ['HNT/USD'],
                ['ICP/USD'],
                ['IMX/USD'],
                ['JOE/USD'],
                ['KDA/USD'],
                ['KSM/USD'],
                ['LDO/USD'],
                ['LINK/USD'],
                ['LQTY/USD'],
                ['LTC/USD'],
                ['MANA/USD'],
                ['MKR/USD'],
                ['METIS/USD'],
                ['MOVR/USD'],
                ['NEAR/USD'],
                ['OKB/USD'],
                ['OP/USD'],
                ['PAXG/USD'],
                ['QUICK/USD'],
                ['ROSE/USD'],
                ['RPL/USD'],
                ['RSR/USD'],
                ['RUNE/USD'],
                ['SAND/USD'],
                ['SHIB/USD'],
                ['SNX/USD'],
                ['SOL/USD'],
                ['stETH/USD'],
                ['STG/USD'],
                ['STX/USD'],
                ['SUSHI/USD'],
                ['TUSD/USD'],
                ['UNI/USD'],
                ['USDT/USD'],
                ['USDC/USD'],
                ['USDP/USD'],
                ['WBTC/USD'],
                ['XLM/USD'],
                ['XRP/USD'],
                ['XTZ/USD'],
                ['YFI/USD'],
                ['ZIL/USD'],
                ['ZRX/USD'],
                ['MASK/USD'],
                ['ENS/USD'],
                ['BLUR/USD'],
                ['BAND/USD'],
                ['UMA/USD'],
                ['APT/USD'],
                ['OSMO/USD'],
                ['SUI/USD'],
                ['GNS/USD'],
                ['MNT/USD'],
                ['KAVA/USD'],
                ['RDNT/USD'],
                ['RIF/USD'],
                ['GHO/USD'],
                ['crvUSD/USD'],
                ['EURe/USD'],
                ['FRAX/USD'],
                ['LUSD/USD'],
                ['WOO/USD'],
                ['PYTH/USD'],
                ['USDe/USD'],
                ['ASTR/USD'],
                ['TIA/USD'],
                ['DYM/USD'],
                ['SEI/USD'],
                ['AR/USD'],
                ['STRK/USD'],
                ['AXL/USD'],
                ['ONDO/USD'],
                ['MANTA/USD'],
                ['RON/USD'],
                ['XVS/USD'],
                ['PENDLE/USD'],
                ['TWT/USD'],
                ['AERO/USD'],
                ['TAO/USD'],
                ['stTAO/TAO Exchange Rate'],
                ['PYUSD/USD'],
                ['MERL/USD'],
                ['ORDI/USD'],
                ['SATS/USD'],
                ['sFRAX/FRAX Exchange Rate'],
                ['INJ/USD'],
                ['MODE/USD'],
                ['NEON/USD'],
                ['RARI/USD'],
                ['CORE/USD'],
                ['DEGEN/USD'],
                ['ENA/USD'],
                ['FDUSD/USD'],
                ['WLD/USD'],
                ['EURC/USD'],
                ['ZRO/USD'],
                ['ZK/USD'],
                ['ETHFI/USD'],
                ['SAFE/USD'],
                ['wBETH/ETH Exchange Rate'],
                ['BNBx/BNB Exchange Rate'],
                ['slisBNB/BNB Exchange Rate'],
                ['TAIKO/USD'],
                ['W/USD'],
                ['weETHs/ETH Exchange Rate'],
                ['BLAST/USD'],
                ['inETH/ETH Exchange Rate'],
                ['CFX/USD'],
                ['RENDER/USD'],
                ['ankrETH/ETH Exchange Rate'],
                ['ultraETHs/wstETH Exchange Rate'],
                ['agETH/rsETH Exchange Rate'],
                ['POL/USD'],
                ['eBTC/WBTC Exchange Rate'],
                ['AUSD/USD'],
                ['FBTC/USD'],
                ['LUMIA/USD'],
                ['cmETH/mETH Exchange Rate'],
                ['LsETH/ETH Exchange Rate'],
                ['insfrxETH/sfrxETH Exchange Rate'],
                ['egETH/ETH Exchange Rate'],
                ['mstETH/ETH Exchange Rate'],
                ['SCR/USD'],
                ['COOK/USD'],
                ['cbBTC/USD'],
                ['BRETT/USD'],
                ['MORPHO/USD'],
                ['yUSD/USD Exchange Rate'],
                ['SolvBTC/USD'],
                ['ZRC/USD'],
                ['inwstETHs/wstETH Exchange Rate'],
                ['LBTC/USD'],
                ['S/USD'],
                ['VELO/USD'],
                ['scrvUSD/crvUSD Exchange Rate'],
                ['MTL/USD'],
                ['BERA/USD'],
                ['sUSDS/USDS Exchange Rate'],
                ['USDS/USD'],
                ['ysUSDC/USDC Exchange Rate'],
                ['sfrxUSD/frxUSD Exchange Rate'],
                ['HYPE/USD'],
                ['VET/USD'],
                ['tBTC/USD'],
                ['VTHO/USD'],
                ['MVL/USD'],
                ['frxUSD/USD'],
                ['VIRTUAL/USD'],
                ['osETH/ETH Exchange Rate'],
                ['SPK/USD'],
                ['SYRUP/USD'],
                ['RESOLV/USD'],
                ['XAUt/USD'],
                ['EUR/USD'],
                ['WELL/USD'],
                ['wOS/OS Exchange Rate'],
                ['USD1/USD']
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    nodary: {
        alias: 'nodary',
        name: 'Nodary',
        providerType: 'rest',
        airnode: '0xc52EeA00154B4fF1EbbF8Ba39FDe37F1AC3B9Fd4',
        previousAirnodes: [],
        xpub: 'xpub6Cd14fbNsTqhi7Urd3cyXHD1nfpDyFf2b5jLcNcwtcEiGzJpQ9UNDwNinYCEmoXgCEZyMZYmAPCaGCFBuCqMD8Pkz8zXWt4rgre8kQLFUMA',
        supportedFeedsInBatches: {
            Nodary: [
                ['cbETH/ETH Exchange Rate'],
                ['rETH/ETH Exchange Rate'],
                ['sfrxETH/frxETH Exchange Rate'],
                ['swETH/ETH Exchange Rate'],
                ['wstETH/stETH Exchange Rate'],
                ['mETH/ETH Exchange Rate'],
                ['MATICx/MATIC Exchange Rate'],
                ['ETHx/ETH Exchange Rate'],
                ['uniETH/ETH Exchange Rate'],
                ['weETH/ETH Exchange Rate'],
                ['STONE/ETH Exchange Rate'],
                ['USDY/USD Exchange Rate'],
                ['rsETH/ETH Exchange Rate'],
                ['rswETH/ETH Exchange Rate'],
                ['apxETH/pxETH Exchange Rate'],
                ['ezETH/ETH Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['sDAI/DAI Exchange Rate'],
                ['sUSDe/USDe Exchange Rate'],
                ['pufETH/stETH Exchange Rate'],
                ['instETH/stETH Exchange Rate'],
                ['AAVE/USD'],
                ['ADA/USD'],
                ['ALGO/USD'],
                ['ANKR/USD'],
                ['APE/USD'],
                ['API3/USD'],
                ['ARB/USD'],
                ['ATOM/USD'],
                ['AVAX/USD'],
                ['AXS/USD'],
                ['BAL/USD'],
                ['BAT/USD'],
                ['BNB/USD'],
                ['BTC/USD'],
                ['CAKE/USD'],
                ['CELO/USD'],
                ['CHZ/USD'],
                ['COMP/USD'],
                ['CRO/USD'],
                ['CRV/USD'],
                ['CVX/USD'],
                ['DAI/USD'],
                ['DOGE/USD'],
                ['DOT/USD'],
                ['DYDX/USD'],
                ['ETH/USD'],
                ['FIL/USD'],
                ['FLOW/USD'],
                ['FXS/USD'],
                ['GLMR/USD'],
                ['GMX/USD'],
                ['GNO/USD'],
                ['GRT/USD'],
                ['HBAR/USD'],
                ['HNT/USD'],
                ['ICP/USD'],
                ['IMX/USD'],
                ['JOE/USD'],
                ['KDA/USD'],
                ['KSM/USD'],
                ['LDO/USD'],
                ['LINK/USD'],
                ['LQTY/USD'],
                ['LTC/USD'],
                ['MANA/USD'],
                ['MKR/USD'],
                ['METIS/USD'],
                ['MOVR/USD'],
                ['NEAR/USD'],
                ['OKB/USD'],
                ['OP/USD'],
                ['PAXG/USD'],
                ['QUICK/USD'],
                ['ROSE/USD'],
                ['RPL/USD'],
                ['RSR/USD'],
                ['RUNE/USD'],
                ['SAND/USD'],
                ['SHIB/USD'],
                ['SNX/USD'],
                ['SOL/USD'],
                ['stETH/USD'],
                ['STG/USD'],
                ['STX/USD'],
                ['SUSHI/USD'],
                ['TUSD/USD'],
                ['UNI/USD'],
                ['USDT/USD'],
                ['USDC/USD'],
                ['USDP/USD'],
                ['WBTC/USD'],
                ['XLM/USD'],
                ['XRP/USD'],
                ['XTZ/USD'],
                ['YFI/USD'],
                ['ZIL/USD'],
                ['ZRX/USD'],
                ['MASK/USD'],
                ['ENS/USD'],
                ['BLUR/USD'],
                ['BAND/USD'],
                ['UMA/USD'],
                ['APT/USD'],
                ['OSMO/USD'],
                ['SUI/USD'],
                ['GNS/USD'],
                ['MNT/USD'],
                ['KAVA/USD'],
                ['RDNT/USD'],
                ['RIF/USD'],
                ['GHO/USD'],
                ['crvUSD/USD'],
                ['EURe/USD'],
                ['FRAX/USD'],
                ['LUSD/USD'],
                ['WOO/USD'],
                ['PYTH/USD'],
                ['USDe/USD'],
                ['ASTR/USD'],
                ['TIA/USD'],
                ['DYM/USD'],
                ['SEI/USD'],
                ['AR/USD'],
                ['STRK/USD'],
                ['AXL/USD'],
                ['ONDO/USD'],
                ['MANTA/USD'],
                ['RON/USD'],
                ['XVS/USD'],
                ['PENDLE/USD'],
                ['TWT/USD'],
                ['AERO/USD'],
                ['TAO/USD'],
                ['stTAO/TAO Exchange Rate'],
                ['PYUSD/USD'],
                ['MERL/USD'],
                ['ORDI/USD'],
                ['SATS/USD'],
                ['sFRAX/FRAX Exchange Rate'],
                ['INJ/USD'],
                ['MODE/USD'],
                ['NEON/USD'],
                ['RARI/USD'],
                ['CORE/USD'],
                ['DEGEN/USD'],
                ['ENA/USD'],
                ['FDUSD/USD'],
                ['WLD/USD'],
                ['EURC/USD'],
                ['ZRO/USD'],
                ['ZK/USD'],
                ['ETHFI/USD'],
                ['SAFE/USD'],
                ['wBETH/ETH Exchange Rate'],
                ['BNBx/BNB Exchange Rate'],
                ['slisBNB/BNB Exchange Rate'],
                ['TAIKO/USD'],
                ['W/USD'],
                ['weETHs/ETH Exchange Rate'],
                ['BLAST/USD'],
                ['inETH/ETH Exchange Rate'],
                ['CFX/USD'],
                ['RENDER/USD'],
                ['ankrETH/ETH Exchange Rate'],
                ['ultraETHs/wstETH Exchange Rate'],
                ['agETH/rsETH Exchange Rate'],
                ['POL/USD'],
                ['eBTC/WBTC Exchange Rate'],
                ['AUSD/USD'],
                ['FBTC/USD'],
                ['LUMIA/USD'],
                ['cmETH/mETH Exchange Rate'],
                ['LsETH/ETH Exchange Rate'],
                ['insfrxETH/sfrxETH Exchange Rate'],
                ['egETH/ETH Exchange Rate'],
                ['mstETH/ETH Exchange Rate'],
                ['SCR/USD'],
                ['COOK/USD'],
                ['cbBTC/USD'],
                ['BRETT/USD'],
                ['MORPHO/USD'],
                ['yUSD/USD Exchange Rate'],
                ['SolvBTC/USD'],
                ['ZRC/USD'],
                ['inwstETHs/wstETH Exchange Rate'],
                ['LBTC/USD'],
                ['S/USD'],
                ['VELO/USD'],
                ['scrvUSD/crvUSD Exchange Rate'],
                ['MTL/USD'],
                ['BERA/USD'],
                ['sUSDS/USDS Exchange Rate'],
                ['USDS/USD'],
                ['ysUSDC/USDC Exchange Rate'],
                ['sfrxUSD/frxUSD Exchange Rate'],
                ['HYPE/USD'],
                ['VET/USD'],
                ['tBTC/USD'],
                ['VTHO/USD'],
                ['MVL/USD'],
                ['frxUSD/USD'],
                ['VIRTUAL/USD'],
                ['osETH/ETH Exchange Rate'],
                ['SPK/USD'],
                ['SYRUP/USD'],
                ['RESOLV/USD'],
                ['XAUt/USD'],
                ['EUR/USD'],
                ['WELL/USD'],
                ['wOS/OS Exchange Rate'],
                ['USD1/USD']
            ]
        },
        deploymentConfigurations: [
            { signedApi: false, region: 'eu-north-1', provider: 'aws' },
            { signedApi: false, region: 'us-east-1', provider: 'aws' }
        ],
        homepageUrl: 'https://nodary.io',
        verifiedBaseUrl: 'https://nodary.io',
        signedApiUrl: 'https://signed-api.nodary.io',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'ncfx-mock': {
        alias: 'ncfx-mock',
        name: 'NCFX-Mock',
        providerType: 'rest',
        airnode: '0x220Ad4917B349F69288E892e50E929A693B71920',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            'NewChangeFX-Crypto': [
                [
                    'AAVE/USD',
                    'ADA/USD',
                    'ALGO/USD',
                    'ANKR/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'ATOM/USD',
                    'AVAX/USD',
                    'AXS/USD',
                    'BAL/USD',
                    'BAT/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'CHZ/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOGE/USD',
                    'DOT/USD',
                    'DYDX/USD',
                    'ETH/USD',
                    'FIL/USD',
                    'FLOW/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'GRT/USD',
                    'HBAR/USD',
                    'HNT/USD',
                    'ICP/USD',
                    'IMX/USD',
                    'JOE/USD',
                    'KDA/USD',
                    'KSM/USD',
                    'LDO/USD',
                    'LINK/USD',
                    'LQTY/USD',
                    'LTC/USD',
                    'MANA/USD',
                    'MKR/USD',
                    'METIS/USD',
                    'MOVR/USD',
                    'NEAR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'ROSE/USD',
                    'RPL/USD',
                    'RSR/USD',
                    'RUNE/USD',
                    'SAND/USD',
                    'SHIB/USD',
                    'SNX/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'STG/USD',
                    'STX/USD',
                    'SUSHI/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XLM/USD',
                    'XRP/USD',
                    'XTZ/USD',
                    'YFI/USD',
                    'ZIL/USD',
                    'ZRX/USD',
                    'MASK/USD',
                    'ENS/USD',
                    'BLUR/USD',
                    'BAND/USD',
                    'UMA/USD',
                    'APT/USD',
                    'OSMO/USD',
                    'SUI/USD',
                    'KAVA/USD',
                    'MNT/USD',
                    'RDNT/USD',
                    'RIF/USD',
                    'WOO/USD',
                    'PYTH/USD',
                    'ASTR/USD',
                    'TIA/USD',
                    'DYM/USD',
                    'SEI/USD',
                    'AR/USD',
                    'STRK/USD',
                    'AXL/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'XVS/USD',
                    'PENDLE/USD',
                    'TWT/USD',
                    'AERO/USD',
                    'TAO/USD',
                    'PYUSD/USD',
                    'ORDI/USD',
                    'INJ/USD',
                    'MODE/USD',
                    'RARI/USD',
                    'DEGEN/USD',
                    'CORE/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'SAFE/USD',
                    'QUICK/USD',
                    'BLAST/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'CFX/USD',
                    'RENDER/USD',
                    'EURC/USD',
                    'MERL/USD',
                    'NEON/USD',
                    'TAIKO/USD',
                    'USDe/USD',
                    'COOK/USD',
                    'SCR/USD',
                    'BRETT/USD',
                    'LUMIA/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'MTL/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'POL/USD',
                    'HYPE/USD',
                    'ETHFI/USD',
                    'GNS/USD',
                    'ENA/USD',
                    'VET/USD',
                    'SATS/USD',
                    'VTHO/USD',
                    'MVL/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'RESOLV/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'RLUSD/USD',
                    'USDD/USD',
                    'USDG/USD',
                    'WELL/USD'
                ]
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    ncfx: {
        alias: 'ncfx',
        name: 'NCFX',
        providerType: 'rest',
        airnode: '0xbC6471E88d8aFe936A45bEB8bd20a210EBEF6822',
        previousAirnodes: [],
        xpub: 'xpub6D1KuAee1Ubp3LcU76tUvrtjdoKFcU87CCBVKxYZCz3ejDRuRyYN9znp6TGv9rnTSujP7LfSirz5enf4EsUi58KbKBngsiwb8SDwZZ6pukB',
        supportedFeedsInBatches: {
            'NewChangeFX-Crypto': [
                [
                    'AAVE/USD',
                    'ADA/USD',
                    'ALGO/USD',
                    'ANKR/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'ATOM/USD',
                    'AVAX/USD',
                    'AXS/USD',
                    'BAL/USD',
                    'BAT/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'CHZ/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOGE/USD',
                    'DOT/USD',
                    'DYDX/USD',
                    'ETH/USD',
                    'FIL/USD',
                    'FLOW/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'GRT/USD',
                    'HBAR/USD',
                    'HNT/USD',
                    'ICP/USD',
                    'IMX/USD',
                    'JOE/USD',
                    'KDA/USD',
                    'KSM/USD',
                    'LDO/USD',
                    'LINK/USD',
                    'LQTY/USD',
                    'LTC/USD',
                    'MANA/USD',
                    'MKR/USD',
                    'METIS/USD',
                    'MOVR/USD',
                    'NEAR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'ROSE/USD',
                    'RPL/USD',
                    'RSR/USD',
                    'RUNE/USD',
                    'SAND/USD',
                    'SHIB/USD',
                    'SNX/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'STG/USD',
                    'STX/USD',
                    'SUSHI/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XLM/USD',
                    'XRP/USD',
                    'XTZ/USD',
                    'YFI/USD',
                    'ZIL/USD',
                    'ZRX/USD',
                    'MASK/USD',
                    'ENS/USD',
                    'BLUR/USD',
                    'BAND/USD',
                    'UMA/USD',
                    'APT/USD',
                    'OSMO/USD',
                    'SUI/USD',
                    'KAVA/USD',
                    'MNT/USD',
                    'RDNT/USD',
                    'RIF/USD',
                    'WOO/USD',
                    'PYTH/USD',
                    'ASTR/USD',
                    'TIA/USD',
                    'DYM/USD',
                    'SEI/USD',
                    'AR/USD',
                    'STRK/USD',
                    'AXL/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'XVS/USD',
                    'PENDLE/USD',
                    'TWT/USD',
                    'AERO/USD',
                    'TAO/USD',
                    'PYUSD/USD',
                    'ORDI/USD',
                    'INJ/USD',
                    'MODE/USD',
                    'RARI/USD',
                    'DEGEN/USD',
                    'CORE/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'SAFE/USD',
                    'QUICK/USD',
                    'BLAST/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'CFX/USD',
                    'RENDER/USD',
                    'EURC/USD',
                    'MERL/USD',
                    'NEON/USD',
                    'TAIKO/USD',
                    'USDe/USD',
                    'COOK/USD',
                    'SCR/USD',
                    'BRETT/USD',
                    'LUMIA/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'S/USD',
                    'VELO/USD',
                    'MTL/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'POL/USD',
                    'HYPE/USD',
                    'ETHFI/USD',
                    'GNS/USD',
                    'ENA/USD',
                    'VET/USD',
                    'SATS/USD',
                    'VTHO/USD',
                    'MVL/USD',
                    'VIRTUAL/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'RESOLV/USD',
                    'XAUt/USD',
                    'USD1/USD'
                ]
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'eu-west-2', provider: 'aws' },
            { signedApi: false, region: 'us-east-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.newchangefx.com',
        verifiedBaseUrl: 'https://newchangefx.com',
        signedApiUrl: 'https://signed-api.newchangefx.com',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'infura-mock': {
        alias: 'infura-mock',
        name: 'Infura-Mock',
        providerType: 'rpc',
        airnode: '0x4D81964F58409651eF5C191166a9Ff6e6b40986f',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            Infura: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'ETHx/ETH Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'weETHs/ETH Exchange Rate',
                    'inETH/ETH Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'ultraETHs/wstETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'instETH/stETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'insfrxETH/sfrxETH Exchange Rate',
                    'egETH/ETH Exchange Rate',
                    'mstETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'inwstETHs/wstETH Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['USDY/USD Exchange Rate'],
                ['wOS/OS Exchange Rate']
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    infura: {
        alias: 'infura',
        name: 'Infura',
        providerType: 'rpc',
        airnode: '0x72bFf91fc62E03f917D5c1202225f92f74cBe67e',
        previousAirnodes: [],
        xpub: 'xpub6C9AUv96zC5cBpsNxkun9Csvdo4eDjj6o9cVLW1gx7LTma7eXnHFiDPmdXBT5q5PCqaxTNyrPa2h6LaH8Q7ag7xgmnmAnCHETkc9UN63MQ4',
        supportedFeedsInBatches: {
            Infura: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'ETHx/ETH Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'weETHs/ETH Exchange Rate',
                    'inETH/ETH Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'ultraETHs/wstETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'instETH/stETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'insfrxETH/sfrxETH Exchange Rate',
                    'egETH/ETH Exchange Rate',
                    'mstETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'inwstETHs/wstETH Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['USDY/USD Exchange Rate']
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'us-east-1', provider: 'aws' },
            { signedApi: false, region: 'eu-west-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.infura.io',
        verifiedBaseUrl: 'https://infura.io',
        signedApiUrl: 'https://signed-api.infura.io',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'finage-mock': {
        alias: 'finage-mock',
        name: 'Finage-Mock',
        providerType: 'rest',
        airnode: '0xD7AD63b84F03FF923a690bAE32C988097C70C673',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            Finage: [
                ['AAVE/USD'],
                ['ADA/USD'],
                ['ALGO/USD'],
                ['ANKR/USD'],
                ['APE/USD'],
                ['API3/USD'],
                ['ARB/USD'],
                ['ATOM/USD'],
                ['AVAX/USD'],
                ['AXS/USD'],
                ['BAL/USD'],
                ['BAT/USD'],
                ['BNB/USD'],
                ['BTC/USD'],
                ['CAKE/USD'],
                ['CELO/USD'],
                ['CHZ/USD'],
                ['COMP/USD'],
                ['CRO/USD'],
                ['CRV/USD'],
                ['CVX/USD'],
                ['DAI/USD'],
                ['DOGE/USD'],
                ['DOT/USD'],
                ['DYDX/USD'],
                ['ETH/USD'],
                ['FIL/USD'],
                ['FLOW/USD'],
                ['FXS/USD'],
                ['GLMR/USD'],
                ['GMX/USD'],
                ['GNO/USD'],
                ['GRT/USD'],
                ['HBAR/USD'],
                ['HNT/USD'],
                ['ICP/USD'],
                ['IMX/USD'],
                ['JOE/USD'],
                ['KDA/USD'],
                ['KSM/USD'],
                ['LDO/USD'],
                ['LINK/USD'],
                ['LQTY/USD'],
                ['LTC/USD'],
                ['MANA/USD'],
                ['MKR/USD'],
                ['METIS/USD'],
                ['MOVR/USD'],
                ['NEAR/USD'],
                ['OKB/USD'],
                ['OP/USD'],
                ['PAXG/USD'],
                ['QUICK/USD'],
                ['ROSE/USD'],
                ['RPL/USD'],
                ['RSR/USD'],
                ['RUNE/USD'],
                ['SAND/USD'],
                ['SHIB/USD'],
                ['SNX/USD'],
                ['SOL/USD'],
                ['STG/USD'],
                ['STX/USD'],
                ['SUSHI/USD'],
                ['TUSD/USD'],
                ['UNI/USD'],
                ['USDT/USD'],
                ['USDC/USD'],
                ['USDP/USD'],
                ['WBTC/USD'],
                ['XLM/USD'],
                ['XRP/USD'],
                ['XTZ/USD'],
                ['YFI/USD'],
                ['ZIL/USD'],
                ['ZRX/USD'],
                ['MASK/USD'],
                ['ENS/USD'],
                ['BLUR/USD'],
                ['BAND/USD'],
                ['UMA/USD'],
                ['APT/USD'],
                ['stETH/USD'],
                ['OSMO/USD'],
                ['SUI/USD'],
                ['GNS/USD'],
                ['FRAX/USD'],
                ['LUSD/USD'],
                ['MNT/USD'],
                ['KAVA/USD'],
                ['RIF/USD'],
                ['RDNT/USD'],
                ['GHO/USD'],
                ['crvUSD/USD'],
                ['EURe/USD'],
                ['WOO/USD'],
                ['PYTH/USD'],
                ['USDe/USD'],
                ['ASTR/USD'],
                ['DYM/USD'],
                ['TIA/USD'],
                ['SEI/USD'],
                ['AR/USD'],
                ['STRK/USD'],
                ['AXL/USD'],
                ['ONDO/USD'],
                ['MANTA/USD'],
                ['RON/USD'],
                ['XVS/USD'],
                ['PENDLE/USD'],
                ['TWT/USD'],
                ['AERO/USD'],
                ['TAO/USD'],
                ['PYUSD/USD'],
                ['MERL/USD'],
                ['ORDI/USD'],
                ['SATS/USD'],
                ['NEON/USD'],
                ['INJ/USD'],
                ['RARI/USD'],
                ['CORE/USD'],
                ['DEGEN/USD'],
                ['ENA/USD'],
                ['FDUSD/USD'],
                ['WLD/USD'],
                ['ETHFI/USD'],
                ['SAFE/USD'],
                ['TAIKO/USD'],
                ['W/USD'],
                ['BLAST/USD'],
                ['ZRO/USD'],
                ['ZK/USD'],
                ['CFX/USD'],
                ['RENDER/USD'],
                ['POL/USD'],
                ['LUMIA/USD'],
                ['FBTC/USD'],
                ['AUSD/USD'],
                ['EURC/USD'],
                ['BRETT/USD'],
                ['COOK/USD'],
                ['SCR/USD'],
                ['MORPHO/USD'],
                ['cbBTC/USD'],
                ['SolvBTC/USD'],
                ['ZRC/USD'],
                ['LBTC/USD'],
                ['S/USD'],
                ['VELO/USD'],
                ['MTL/USD'],
                ['BERA/USD'],
                ['USDS/USD'],
                ['HYPE/USD'],
                ['VET/USD'],
                ['tBTC/USD'],
                ['frxUSD/USD'],
                ['VTHO/USD'],
                ['MVL/USD'],
                ['VIRTUAL/USD'],
                ['DOLA/USD'],
                ['SPK/USD'],
                ['SYRUP/USD'],
                ['RESOLV/USD'],
                ['XAUt/USD'],
                ['USD1/USD'],
                ['USDY/USD'],
                ['USDD/USD'],
                ['USDG/USD'],
                ['BUSD/USD'],
                ['EUR/USD'],
                ['WELL/USD']
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    finage: {
        alias: 'finage',
        name: 'Finage',
        providerType: 'rest',
        airnode: '0xa924847354c551C79BAE7E75529364bA0449e51A',
        previousAirnodes: [],
        xpub: 'xpub6CFWer6kWqCwTQLLfMTVviYeHKmDvXM4Leq8AwUBE9XNqmQYAmgtGZnxKo6rxypmGRpeZjSZy8gHUNJioeZVrHnb6RyjsZs3MkeMoaL1JbV',
        supportedFeedsInBatches: {
            Finage: [
                ['AAVE/USD'],
                ['ADA/USD'],
                ['ALGO/USD'],
                ['ANKR/USD'],
                ['APE/USD'],
                ['API3/USD'],
                ['ARB/USD'],
                ['ATOM/USD'],
                ['AVAX/USD'],
                ['AXS/USD'],
                ['BAL/USD'],
                ['BAT/USD'],
                ['BNB/USD'],
                ['BTC/USD'],
                ['CAKE/USD'],
                ['CELO/USD'],
                ['CHZ/USD'],
                ['COMP/USD'],
                ['CRO/USD'],
                ['CRV/USD'],
                ['CVX/USD'],
                ['DAI/USD'],
                ['DOGE/USD'],
                ['DOT/USD'],
                ['DYDX/USD'],
                ['ETH/USD'],
                ['FIL/USD'],
                ['FLOW/USD'],
                ['FXS/USD'],
                ['GLMR/USD'],
                ['GMX/USD'],
                ['GNO/USD'],
                ['GRT/USD'],
                ['HBAR/USD'],
                ['HNT/USD'],
                ['ICP/USD'],
                ['IMX/USD'],
                ['JOE/USD'],
                ['KDA/USD'],
                ['KSM/USD'],
                ['LDO/USD'],
                ['LINK/USD'],
                ['LQTY/USD'],
                ['LTC/USD'],
                ['MANA/USD'],
                ['MKR/USD'],
                ['METIS/USD'],
                ['MOVR/USD'],
                ['NEAR/USD'],
                ['OKB/USD'],
                ['OP/USD'],
                ['PAXG/USD'],
                ['QUICK/USD'],
                ['ROSE/USD'],
                ['RPL/USD'],
                ['RSR/USD'],
                ['RUNE/USD'],
                ['SAND/USD'],
                ['SHIB/USD'],
                ['SNX/USD'],
                ['SOL/USD'],
                ['STG/USD'],
                ['STX/USD'],
                ['SUSHI/USD'],
                ['TUSD/USD'],
                ['UNI/USD'],
                ['USDT/USD'],
                ['USDC/USD'],
                ['USDP/USD'],
                ['WBTC/USD'],
                ['XLM/USD'],
                ['XRP/USD'],
                ['XTZ/USD'],
                ['YFI/USD'],
                ['ZIL/USD'],
                ['ZRX/USD'],
                ['MASK/USD'],
                ['ENS/USD'],
                ['BLUR/USD'],
                ['BAND/USD'],
                ['UMA/USD'],
                ['APT/USD'],
                ['stETH/USD'],
                ['OSMO/USD'],
                ['SUI/USD'],
                ['GNS/USD'],
                ['FRAX/USD'],
                ['LUSD/USD'],
                ['MNT/USD'],
                ['KAVA/USD'],
                ['RIF/USD'],
                ['RDNT/USD'],
                ['GHO/USD'],
                ['crvUSD/USD'],
                ['EURe/USD'],
                ['WOO/USD'],
                ['PYTH/USD'],
                ['USDe/USD'],
                ['ASTR/USD'],
                ['DYM/USD'],
                ['TIA/USD'],
                ['SEI/USD'],
                ['AR/USD'],
                ['STRK/USD'],
                ['AXL/USD'],
                ['ONDO/USD'],
                ['MANTA/USD'],
                ['RON/USD'],
                ['XVS/USD'],
                ['PENDLE/USD'],
                ['TWT/USD'],
                ['AERO/USD'],
                ['TAO/USD'],
                ['PYUSD/USD'],
                ['MERL/USD'],
                ['ORDI/USD'],
                ['SATS/USD'],
                ['NEON/USD'],
                ['INJ/USD'],
                ['RARI/USD'],
                ['CORE/USD'],
                ['DEGEN/USD'],
                ['ENA/USD'],
                ['FDUSD/USD'],
                ['WLD/USD'],
                ['ETHFI/USD'],
                ['SAFE/USD'],
                ['TAIKO/USD'],
                ['W/USD'],
                ['BLAST/USD'],
                ['ZRO/USD'],
                ['ZK/USD'],
                ['CFX/USD'],
                ['RENDER/USD'],
                ['POL/USD'],
                ['LUMIA/USD'],
                ['FBTC/USD'],
                ['AUSD/USD'],
                ['EURC/USD'],
                ['BRETT/USD'],
                ['COOK/USD'],
                ['SCR/USD'],
                ['MORPHO/USD'],
                ['cbBTC/USD'],
                ['SolvBTC/USD'],
                ['ZRC/USD'],
                ['LBTC/USD'],
                ['S/USD'],
                ['VELO/USD'],
                ['MTL/USD'],
                ['BERA/USD'],
                ['USDS/USD'],
                ['HYPE/USD'],
                ['VET/USD'],
                ['tBTC/USD'],
                ['frxUSD/USD'],
                ['VTHO/USD'],
                ['MVL/USD'],
                ['VIRTUAL/USD'],
                ['DOLA/USD'],
                ['SPK/USD'],
                ['SYRUP/USD'],
                ['RESOLV/USD'],
                ['XAUt/USD'],
                ['USD1/USD']
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'eu-west-2', provider: 'aws' },
            { signedApi: false, region: 'us-east-1', provider: 'aws' }
        ],
        homepageUrl: 'https://finage.co.uk',
        verifiedBaseUrl: 'https://finage.co.uk',
        signedApiUrl: 'https://signed-api.finage.co.uk',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'dxfeed-mock': {
        alias: 'dxfeed-mock',
        name: 'dxFeed-Mock',
        providerType: 'rest',
        airnode: '0xC479695045E1730bDE7697c6eD9442cB4A6Da6a0',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            dxFeed: [
                ['AAVE/USD'],
                ['ALGO/USD'],
                ['ANKR/USD'],
                ['APE/USD'],
                ['API3/USD'],
                ['APT/USD'],
                ['ARB/USD'],
                ['ATOM/USD'],
                ['AVAX/USD'],
                ['AXS/USD'],
                ['BAL/USD'],
                ['BAND/USD'],
                ['BAT/USD'],
                ['BLUR/USD'],
                ['BNB/USD'],
                ['CAKE/USD'],
                ['CELO/USD'],
                ['CHZ/USD'],
                ['COMP/USD'],
                ['CRO/USD'],
                ['CRV/USD'],
                ['CVX/USD'],
                ['DAI/USD'],
                ['DOT/USD'],
                ['DYDX/USD'],
                ['ENS/USD'],
                ['FIL/USD'],
                ['FLOW/USD'],
                ['FXS/USD'],
                ['GLMR/USD'],
                ['GMX/USD'],
                ['GNO/USD'],
                ['GRT/USD'],
                ['HNT/USD'],
                ['ICP/USD'],
                ['IMX/USD'],
                ['JOE/USD'],
                ['KSM/USD'],
                ['LDO/USD'],
                ['LINK/USD'],
                ['LTC/USD'],
                ['MANA/USD'],
                ['MASK/USD'],
                ['MKR/USD'],
                ['MOVR/USD'],
                ['NEAR/USD'],
                ['PAXG/USD'],
                ['RPL/USD'],
                ['RSR/USD'],
                ['RUNE/USD'],
                ['SAND/USD'],
                ['SHIB/USD'],
                ['SNX/USD'],
                ['SOL/USD'],
                ['STG/USD'],
                ['STX/USD'],
                ['SUSHI/USD'],
                ['TUSD/USD'],
                ['UMA/USD'],
                ['UNI/USD'],
                ['USDP/USD'],
                ['USDT/USD'],
                ['XLM/USD'],
                ['XTZ/USD'],
                ['YFI/USD'],
                ['ADA/USD'],
                ['BTC/USD'],
                ['ETH/USD'],
                ['XRP/USD'],
                ['DOGE/USD'],
                ['USDC/USD'],
                ['ASTR/USD'],
                ['ZRX/USD'],
                ['SUI/USD'],
                ['WOO/USD'],
                ['KDA/USD'],
                ['ORDI/USD'],
                ['PYTH/USD'],
                ['WLD/USD'],
                ['XVS/USD'],
                ['SEI/USD'],
                ['MANTA/USD'],
                ['OSMO/USD'],
                ['CFX/USD'],
                ['OP/USD'],
                ['TIA/USD'],
                ['DYM/USD'],
                ['AR/USD'],
                ['STRK/USD'],
                ['AXL/USD'],
                ['ENA/USD'],
                ['ROSE/USD'],
                ['GNS/USD'],
                ['HBAR/USD'],
                ['RDNT/USD'],
                ['INJ/USD'],
                ['PENDLE/USD'],
                ['RIF/USD'],
                ['KAVA/USD'],
                ['WBTC/USD'],
                ['RENDER/USD'],
                ['ETHFI/USD'],
                ['METIS/USD'],
                ['QUICK/USD'],
                ['LQTY/USD'],
                ['ZIL/USD'],
                ['TAO/USD'],
                ['TWT/USD'],
                ['FDUSD/USD'],
                ['MNT/USD'],
                ['MODE/USD'],
                ['OKB/USD'],
                ['ONDO/USD'],
                ['NEON/USD'],
                ['BLAST/USD'],
                ['SATS/USD'],
                ['CORE/USD'],
                ['PYUSD/USD'],
                ['DEGEN/USD'],
                ['FRAX/USD'],
                ['MERL/USD'],
                ['RARI/USD'],
                ['SAFE/USD'],
                ['AERO/USD'],
                ['TAIKO/USD'],
                ['EURC/USD'],
                ['LUMIA/USD'],
                ['BRETT/USD'],
                ['COOK/USD'],
                ['SCR/USD'],
                ['ZRC/USD'],
                ['MORPHO/USD'],
                ['VELO/USD'],
                ['S/USD'],
                ['MTL/USD'],
                ['BERA/USD'],
                ['USDS/USD'],
                ['ZK/USD'],
                ['ZRO/USD'],
                ['POL/USD'],
                ['crvUSD/USD'],
                ['RON/USD'],
                ['stETH/USD'],
                ['tBTC/USD'],
                ['HYPE/USD'],
                ['VET/USD'],
                ['VTHO/USD']
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    dxfeed: {
        alias: 'dxfeed',
        name: 'dxFeed',
        providerType: 'rest',
        airnode: '0x9E3F8344DB06aDFFD1E9C5D6A65b33aFbC321610',
        previousAirnodes: [{ expiryTimestamp: 1748337714, airnodeAddress: '0x11030d4f8eB06F958E763C6f8b165D7CDd98DB6C' }],
        xpub: 'xpub6DWi8fs3sCHjQ3vGcm9V9x1ZnUdfpBD1HCzNWZEq14rCkSCNuh6mbZZiseSgf41eSjAarztgrfhJfbAfgCuvF5rurxEJfuefUHCnNTVEvzU',
        supportedFeedsInBatches: {
            dxFeed: [
                ['AAVE/USD'],
                ['ALGO/USD'],
                ['ANKR/USD'],
                ['APE/USD'],
                ['API3/USD'],
                ['APT/USD'],
                ['ARB/USD'],
                ['ATOM/USD'],
                ['AVAX/USD'],
                ['AXS/USD'],
                ['BAL/USD'],
                ['BAND/USD'],
                ['BAT/USD'],
                ['BLUR/USD'],
                ['BNB/USD'],
                ['CAKE/USD'],
                ['CELO/USD'],
                ['CHZ/USD'],
                ['COMP/USD'],
                ['CRO/USD'],
                ['CRV/USD'],
                ['CVX/USD'],
                ['DAI/USD'],
                ['DOT/USD'],
                ['DYDX/USD'],
                ['ENS/USD'],
                ['FIL/USD'],
                ['FLOW/USD'],
                ['FXS/USD'],
                ['GLMR/USD'],
                ['GMX/USD'],
                ['GNO/USD'],
                ['GRT/USD'],
                ['HNT/USD'],
                ['ICP/USD'],
                ['IMX/USD'],
                ['JOE/USD'],
                ['KSM/USD'],
                ['LDO/USD'],
                ['LINK/USD'],
                ['LTC/USD'],
                ['MANA/USD'],
                ['MASK/USD'],
                ['MKR/USD'],
                ['MOVR/USD'],
                ['NEAR/USD'],
                ['PAXG/USD'],
                ['RPL/USD'],
                ['RSR/USD'],
                ['RUNE/USD'],
                ['SAND/USD'],
                ['SHIB/USD'],
                ['SNX/USD'],
                ['SOL/USD'],
                ['STG/USD'],
                ['STX/USD'],
                ['SUSHI/USD'],
                ['TUSD/USD'],
                ['UMA/USD'],
                ['UNI/USD'],
                ['USDP/USD'],
                ['USDT/USD'],
                ['XLM/USD'],
                ['XTZ/USD'],
                ['YFI/USD'],
                ['ADA/USD'],
                ['BTC/USD'],
                ['ETH/USD'],
                ['XRP/USD'],
                ['DOGE/USD'],
                ['USDC/USD'],
                ['ASTR/USD'],
                ['ZRX/USD'],
                ['SUI/USD'],
                ['WOO/USD'],
                ['KDA/USD'],
                ['ORDI/USD'],
                ['PYTH/USD'],
                ['WLD/USD'],
                ['XVS/USD'],
                ['SEI/USD'],
                ['MANTA/USD'],
                ['OSMO/USD'],
                ['CFX/USD'],
                ['OP/USD'],
                ['TIA/USD'],
                ['DYM/USD'],
                ['AR/USD'],
                ['STRK/USD'],
                ['AXL/USD'],
                ['ENA/USD'],
                ['ROSE/USD'],
                ['GNS/USD'],
                ['HBAR/USD'],
                ['RDNT/USD'],
                ['INJ/USD'],
                ['PENDLE/USD'],
                ['RIF/USD'],
                ['KAVA/USD'],
                ['WBTC/USD'],
                ['RENDER/USD'],
                ['ETHFI/USD'],
                ['METIS/USD'],
                ['QUICK/USD'],
                ['LQTY/USD'],
                ['ZIL/USD'],
                ['TAO/USD'],
                ['TWT/USD'],
                ['FDUSD/USD'],
                ['MNT/USD'],
                ['MODE/USD'],
                ['OKB/USD'],
                ['ONDO/USD'],
                ['NEON/USD'],
                ['BLAST/USD'],
                ['SATS/USD'],
                ['CORE/USD'],
                ['PYUSD/USD'],
                ['DEGEN/USD'],
                ['FRAX/USD'],
                ['MERL/USD'],
                ['RARI/USD'],
                ['SAFE/USD'],
                ['AERO/USD'],
                ['TAIKO/USD'],
                ['EURC/USD'],
                ['LUMIA/USD'],
                ['BRETT/USD'],
                ['COOK/USD'],
                ['SCR/USD'],
                ['ZRC/USD'],
                ['MORPHO/USD'],
                ['VELO/USD'],
                ['S/USD'],
                ['MTL/USD'],
                ['BERA/USD'],
                ['USDS/USD'],
                ['ZK/USD'],
                ['ZRO/USD'],
                ['POL/USD'],
                ['crvUSD/USD'],
                ['RON/USD'],
                ['stETH/USD'],
                ['tBTC/USD'],
                ['HYPE/USD'],
                ['VET/USD'],
                ['VTHO/USD']
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'eu-west-1', provider: 'aws' },
            { signedApi: false, region: 'us-east-2', provider: 'aws' }
        ],
        homepageUrl: 'https://dxfeed.com',
        verifiedBaseUrl: 'https://dxfeed.com',
        signedApiUrl: 'https://signed-api.dxfeed.com',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'drpc-mock': {
        alias: 'drpc-mock',
        name: 'dRPC-Mock',
        providerType: 'rpc',
        airnode: '0xDFCC177437f9Be5e5A0828A620664A4C1321e780',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            dRPC: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'ETHx/ETH Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'weETHs/ETH Exchange Rate',
                    'inETH/ETH Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'ultraETHs/wstETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'instETH/stETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'insfrxETH/sfrxETH Exchange Rate',
                    'egETH/ETH Exchange Rate',
                    'mstETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'inwstETHs/wstETH Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['USDY/USD Exchange Rate'],
                ['wOS/OS Exchange Rate']
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    drpc: {
        alias: 'drpc',
        name: 'dRPC',
        providerType: 'rpc',
        airnode: '0x14F4bC1EC875f4A8d260721B0A7b07262A71a220',
        previousAirnodes: [],
        xpub: 'xpub6CHmnmsEDrQ6M7v94J6tu4beX6jnFueyg9rUCn83X8ZnrqxuDQwFWB4npDWiWoUb6cMJrAsuL5EC2D5gq7BDnsyFzWnNx91qev5Wb6aQuyS',
        supportedFeedsInBatches: {
            dRPC: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'ETHx/ETH Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'weETHs/ETH Exchange Rate',
                    'inETH/ETH Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'ultraETHs/wstETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'instETH/stETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'insfrxETH/sfrxETH Exchange Rate',
                    'egETH/ETH Exchange Rate',
                    'mstETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'inwstETHs/wstETH Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['USDY/USD Exchange Rate']
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'us-east-2', provider: 'aws' },
            { signedApi: false, region: 'eu-central-1', provider: 'aws' }
        ],
        homepageUrl: 'https://drpc.org',
        verifiedBaseUrl: 'https://drpc.org',
        signedApiUrl: 'https://signed-api.drpc.org',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'coinpaprika-mock': {
        alias: 'coinpaprika-mock',
        name: 'CoinPaprika-Mock',
        providerType: 'rest',
        airnode: '0x59493508C6CdE2179100CE2994919Dae38D893b2',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            Coinpaprika: [
                ['AAVE/USD'],
                ['ADA/USD'],
                ['ALGO/USD'],
                ['ANKR/USD'],
                ['APE/USD'],
                ['API3/USD'],
                ['ARB/USD'],
                ['ATOM/USD'],
                ['AVAX/USD'],
                ['AXS/USD'],
                ['BAL/USD'],
                ['BAT/USD'],
                ['BNB/USD'],
                ['BTC/USD'],
                ['CAKE/USD'],
                ['CELO/USD'],
                ['CHZ/USD'],
                ['COMP/USD'],
                ['CRO/USD'],
                ['CRV/USD'],
                ['CVX/USD'],
                ['DAI/USD'],
                ['DOGE/USD'],
                ['DOT/USD'],
                ['DYDX/USD'],
                ['ETH/USD'],
                ['FIL/USD'],
                ['FLOW/USD'],
                ['FXS/USD'],
                ['GLMR/USD'],
                ['GMX/USD'],
                ['GNO/USD'],
                ['GRT/USD'],
                ['HBAR/USD'],
                ['HNT/USD'],
                ['ICP/USD'],
                ['IMX/USD'],
                ['JOE/USD'],
                ['KDA/USD'],
                ['KSM/USD'],
                ['LDO/USD'],
                ['LINK/USD'],
                ['LQTY/USD'],
                ['LTC/USD'],
                ['MANA/USD'],
                ['MKR/USD'],
                ['METIS/USD'],
                ['MOVR/USD'],
                ['NEAR/USD'],
                ['OKB/USD'],
                ['OP/USD'],
                ['PAXG/USD'],
                ['QUICK/USD'],
                ['ROSE/USD'],
                ['RPL/USD'],
                ['RSR/USD'],
                ['RUNE/USD'],
                ['SAND/USD'],
                ['SHIB/USD'],
                ['SNX/USD'],
                ['SOL/USD'],
                ['stETH/USD'],
                ['STG/USD'],
                ['STX/USD'],
                ['SUSHI/USD'],
                ['TUSD/USD'],
                ['UNI/USD'],
                ['USDT/USD'],
                ['USDC/USD'],
                ['USDP/USD'],
                ['WBTC/USD'],
                ['XLM/USD'],
                ['XRP/USD'],
                ['XTZ/USD'],
                ['YFI/USD'],
                ['ZIL/USD'],
                ['ZRX/USD'],
                ['MASK/USD'],
                ['ENS/USD'],
                ['BLUR/USD'],
                ['BAND/USD'],
                ['UMA/USD'],
                ['APT/USD'],
                ['OSMO/USD'],
                ['SUI/USD'],
                ['GNS/USD'],
                ['FRAX/USD'],
                ['crvUSD/USD'],
                ['LUSD/USD'],
                ['GHO/USD'],
                ['MNT/USD'],
                ['KAVA/USD'],
                ['RIF/USD'],
                ['RDNT/USD'],
                ['EURe/USD'],
                ['WOO/USD'],
                ['PYTH/USD'],
                ['USDe/USD'],
                ['ASTR/USD'],
                ['TIA/USD'],
                ['DYM/USD'],
                ['SEI/USD'],
                ['AR/USD'],
                ['STRK/USD'],
                ['AXL/USD'],
                ['ONDO/USD'],
                ['MANTA/USD'],
                ['RON/USD'],
                ['XVS/USD'],
                ['PENDLE/USD'],
                ['TWT/USD'],
                ['AERO/USD'],
                ['TAO/USD'],
                ['PYUSD/USD'],
                ['MERL/USD'],
                ['ORDI/USD'],
                ['SATS/USD'],
                ['NEON/USD'],
                ['INJ/USD'],
                ['RARI/USD'],
                ['MODE/USD'],
                ['CORE/USD'],
                ['DEGEN/USD'],
                ['ENA/USD'],
                ['FDUSD/USD'],
                ['WLD/USD'],
                ['ETHFI/USD'],
                ['SAFE/USD'],
                ['TAIKO/USD'],
                ['W/USD'],
                ['BLAST/USD'],
                ['ZRO/USD'],
                ['ZK/USD'],
                ['CFX/USD'],
                ['RENDER/USD'],
                ['EURC/USD'],
                ['POL/USD'],
                ['AUSD/USD'],
                ['FBTC/USD'],
                ['LUMIA/USD'],
                ['BRETT/USD'],
                ['cbBTC/USD'],
                ['SCR/USD'],
                ['COOK/USD'],
                ['SolvBTC/USD'],
                ['ZRC/USD'],
                ['MORPHO/USD'],
                ['LBTC/USD'],
                ['S/USD'],
                ['VELO/USD'],
                ['MTL/USD'],
                ['BERA/USD'],
                ['USDS/USD'],
                ['frxUSD/USD'],
                ['HYPE/USD'],
                ['VET/USD'],
                ['tBTC/USD'],
                ['VTHO/USD'],
                ['MVL/USD'],
                ['VIRTUAL/USD'],
                ['DOLA/USD'],
                ['SPK/USD'],
                ['SYRUP/USD'],
                ['RESOLV/USD'],
                ['XAUt/USD'],
                ['USD1/USD'],
                ['sUSDS/USD'],
                ['USDtb/USD'],
                ['syrupUSDC/USD'],
                ['USDX/USD'],
                ['USDY/USD'],
                ['USD0/USD'],
                ['USDf/USD'],
                ['RLUSD/USD'],
                ['USDD/USD'],
                ['USDG/USD'],
                ['BUSD/USD'],
                ['USDO/USD'],
                ['USR/USD'],
                ['USDa/USD'],
                ['WELL/USD']
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    coinpaprika: {
        alias: 'coinpaprika',
        name: 'CoinPaprika',
        providerType: 'rest',
        airnode: '0xC9B494D3c6eA3fD42779Df9A136Db10374c98D80',
        previousAirnodes: [],
        xpub: 'xpub6D5v1hEMboS7g4TPs6PUNvChbPof3yvmuTQtPgaVtdz6PorVwy8DfUvdowKWYbMRvvoq4Qt3L2WBGJQDwKevuyrHJVUJAGapo2FkatVG9Ch',
        supportedFeedsInBatches: {
            Coinpaprika: [
                ['AAVE/USD'],
                ['ADA/USD'],
                ['ALGO/USD'],
                ['ANKR/USD'],
                ['APE/USD'],
                ['API3/USD'],
                ['ARB/USD'],
                ['ATOM/USD'],
                ['AVAX/USD'],
                ['AXS/USD'],
                ['BAL/USD'],
                ['BAT/USD'],
                ['BNB/USD'],
                ['BTC/USD'],
                ['CAKE/USD'],
                ['CELO/USD'],
                ['CHZ/USD'],
                ['COMP/USD'],
                ['CRO/USD'],
                ['CRV/USD'],
                ['CVX/USD'],
                ['DAI/USD'],
                ['DOGE/USD'],
                ['DOT/USD'],
                ['DYDX/USD'],
                ['ETH/USD'],
                ['FIL/USD'],
                ['FLOW/USD'],
                ['FXS/USD'],
                ['GLMR/USD'],
                ['GMX/USD'],
                ['GNO/USD'],
                ['GRT/USD'],
                ['HBAR/USD'],
                ['HNT/USD'],
                ['ICP/USD'],
                ['IMX/USD'],
                ['JOE/USD'],
                ['KDA/USD'],
                ['KSM/USD'],
                ['LDO/USD'],
                ['LINK/USD'],
                ['LQTY/USD'],
                ['LTC/USD'],
                ['MANA/USD'],
                ['MKR/USD'],
                ['METIS/USD'],
                ['MOVR/USD'],
                ['NEAR/USD'],
                ['OKB/USD'],
                ['OP/USD'],
                ['PAXG/USD'],
                ['QUICK/USD'],
                ['ROSE/USD'],
                ['RPL/USD'],
                ['RSR/USD'],
                ['RUNE/USD'],
                ['SAND/USD'],
                ['SHIB/USD'],
                ['SNX/USD'],
                ['SOL/USD'],
                ['stETH/USD'],
                ['STG/USD'],
                ['STX/USD'],
                ['SUSHI/USD'],
                ['TUSD/USD'],
                ['UNI/USD'],
                ['USDT/USD'],
                ['USDC/USD'],
                ['USDP/USD'],
                ['WBTC/USD'],
                ['XLM/USD'],
                ['XRP/USD'],
                ['XTZ/USD'],
                ['YFI/USD'],
                ['ZIL/USD'],
                ['ZRX/USD'],
                ['MASK/USD'],
                ['ENS/USD'],
                ['BLUR/USD'],
                ['BAND/USD'],
                ['UMA/USD'],
                ['APT/USD'],
                ['OSMO/USD'],
                ['SUI/USD'],
                ['GNS/USD'],
                ['FRAX/USD'],
                ['crvUSD/USD'],
                ['LUSD/USD'],
                ['GHO/USD'],
                ['MNT/USD'],
                ['KAVA/USD'],
                ['RIF/USD'],
                ['RDNT/USD'],
                ['EURe/USD'],
                ['WOO/USD'],
                ['PYTH/USD'],
                ['USDe/USD'],
                ['ASTR/USD'],
                ['TIA/USD'],
                ['DYM/USD'],
                ['SEI/USD'],
                ['AR/USD'],
                ['STRK/USD'],
                ['AXL/USD'],
                ['ONDO/USD'],
                ['MANTA/USD'],
                ['RON/USD'],
                ['XVS/USD'],
                ['PENDLE/USD'],
                ['TWT/USD'],
                ['AERO/USD'],
                ['TAO/USD'],
                ['PYUSD/USD'],
                ['MERL/USD'],
                ['ORDI/USD'],
                ['SATS/USD'],
                ['NEON/USD'],
                ['INJ/USD'],
                ['RARI/USD'],
                ['MODE/USD'],
                ['CORE/USD'],
                ['DEGEN/USD'],
                ['ENA/USD'],
                ['FDUSD/USD'],
                ['WLD/USD'],
                ['ETHFI/USD'],
                ['SAFE/USD'],
                ['TAIKO/USD'],
                ['W/USD'],
                ['BLAST/USD'],
                ['ZRO/USD'],
                ['ZK/USD'],
                ['CFX/USD'],
                ['RENDER/USD'],
                ['EURC/USD'],
                ['POL/USD'],
                ['AUSD/USD'],
                ['FBTC/USD'],
                ['LUMIA/USD'],
                ['BRETT/USD'],
                ['cbBTC/USD'],
                ['SCR/USD'],
                ['COOK/USD'],
                ['SolvBTC/USD'],
                ['ZRC/USD'],
                ['MORPHO/USD'],
                ['LBTC/USD'],
                ['S/USD'],
                ['VELO/USD'],
                ['MTL/USD'],
                ['BERA/USD'],
                ['USDS/USD'],
                ['frxUSD/USD'],
                ['HYPE/USD'],
                ['VET/USD'],
                ['tBTC/USD'],
                ['VTHO/USD'],
                ['MVL/USD'],
                ['VIRTUAL/USD'],
                ['DOLA/USD'],
                ['SPK/USD'],
                ['SYRUP/USD'],
                ['RESOLV/USD'],
                ['XAUt/USD'],
                ['USD1/USD']
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'us-east-1', provider: 'aws' },
            { signedApi: false, region: 'eu-north-1', provider: 'aws' }
        ],
        homepageUrl: 'https://coinpaprika.com',
        verifiedBaseUrl: 'https://coinpaprika.com',
        signedApiUrl: 'https://signed-api.coinpaprika.com',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'coingecko-mock': {
        alias: 'coingecko-mock',
        name: 'CoinGecko-Mock',
        providerType: 'rest',
        airnode: '0x887cA5E7D4d6CcE427949561CD149983F39c9F02',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            CoinGecko: [
                [
                    'AAVE/USD',
                    'ADA/USD',
                    'ALGO/USD',
                    'ANKR/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'ATOM/USD',
                    'AVAX/USD',
                    'AXS/USD',
                    'BAL/USD',
                    'BAT/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'CHZ/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOGE/USD',
                    'DOT/USD',
                    'DYDX/USD',
                    'ETH/USD',
                    'FIL/USD',
                    'FLOW/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'GRT/USD',
                    'HBAR/USD',
                    'HNT/USD',
                    'ICP/USD',
                    'IMX/USD',
                    'JOE/USD',
                    'KDA/USD',
                    'KSM/USD',
                    'LDO/USD',
                    'LINK/USD',
                    'LQTY/USD',
                    'LTC/USD',
                    'MANA/USD',
                    'MKR/USD',
                    'METIS/USD',
                    'MOVR/USD',
                    'NEAR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'QUICK/USD',
                    'ROSE/USD',
                    'RPL/USD',
                    'RSR/USD',
                    'RUNE/USD',
                    'SAND/USD',
                    'SHIB/USD',
                    'SNX/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'STG/USD',
                    'STX/USD',
                    'SUSHI/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XLM/USD',
                    'XRP/USD',
                    'XTZ/USD',
                    'YFI/USD',
                    'ZIL/USD',
                    'ZRX/USD',
                    'MASK/USD',
                    'ENS/USD',
                    'BLUR/USD',
                    'BAND/USD',
                    'UMA/USD',
                    'APT/USD',
                    'OSMO/USD',
                    'SUI/USD',
                    'GNS/USD',
                    'FRAX/USD',
                    'crvUSD/USD',
                    'LUSD/USD',
                    'GHO/USD',
                    'MNT/USD',
                    'ASTR/USD',
                    'KAVA/USD',
                    'PYTH/USD',
                    'RDNT/USD',
                    'RIF/USD',
                    'WOO/USD',
                    'TIA/USD',
                    'DYM/USD',
                    'USDe/USD',
                    'EURe/USD',
                    'SEI/USD',
                    'AR/USD',
                    'STRK/USD',
                    'AXL/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'XVS/USD',
                    'PENDLE/USD',
                    'TWT/USD',
                    'AERO/USD',
                    'TAO/USD',
                    'PYUSD/USD',
                    'MERL/USD',
                    'ORDI/USD',
                    'SATS/USD',
                    'NEON/USD',
                    'INJ/USD',
                    'RARI/USD',
                    'MODE/USD',
                    'CORE/USD',
                    'DEGEN/USD',
                    'ENA/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'ETHFI/USD',
                    'SAFE/USD',
                    'TAIKO/USD',
                    'W/USD',
                    'BLAST/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'CFX/USD',
                    'RENDER/USD',
                    'POL/USD',
                    'EURC/USD',
                    'FBTC/USD',
                    'AUSD/USD',
                    'LUMIA/USD',
                    'BRETT/USD',
                    'cbBTC/USD',
                    'COOK/USD',
                    'SCR/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'LBTC/USD',
                    'S/USD',
                    'VELO/USD',
                    'MTL/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'frxUSD/USD',
                    'HYPE/USD',
                    'VET/USD',
                    'tBTC/USD',
                    'VTHO/USD',
                    'MVL/USD',
                    'VIRTUAL/USD',
                    'DOLA/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'RESOLV/USD',
                    'XAUt/USD',
                    'USD1/USD',
                    'sUSDS/USD',
                    'USDtb/USD',
                    'syrupUSDC/USD',
                    'USDX/USD',
                    'USDY/USD',
                    'USD0/USD',
                    'USDf/USD',
                    'RLUSD/USD',
                    'USDD/USD',
                    'USDG/USD',
                    'BUSD/USD',
                    'USDO/USD',
                    'USR/USD',
                    'USDa/USD',
                    'WELL/USD'
                ]
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    coingecko: {
        alias: 'coingecko',
        name: 'CoinGecko',
        providerType: 'rest',
        airnode: '0x6b56E47DccFbC82D63Df3da417d26e8B1B877f0f',
        previousAirnodes: [],
        xpub: 'xpub6Bp9GNsZu8Um4du9r6usXvs9eB2Fp8ftCbri114gSJKroJNnZjBFCCvo73XxnBS8WPcEufH2K7w3JsPahjzB1yUPi9P4JoSyyBGC1FLFTZy',
        supportedFeedsInBatches: {
            CoinGecko: [
                [
                    'AAVE/USD',
                    'ADA/USD',
                    'ALGO/USD',
                    'ANKR/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'ATOM/USD',
                    'AVAX/USD',
                    'AXS/USD',
                    'BAL/USD',
                    'BAT/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'CHZ/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOGE/USD',
                    'DOT/USD',
                    'DYDX/USD',
                    'ETH/USD',
                    'FIL/USD',
                    'FLOW/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'GRT/USD',
                    'HBAR/USD',
                    'HNT/USD',
                    'ICP/USD',
                    'IMX/USD',
                    'JOE/USD',
                    'KDA/USD',
                    'KSM/USD',
                    'LDO/USD',
                    'LINK/USD',
                    'LQTY/USD',
                    'LTC/USD',
                    'MANA/USD',
                    'MKR/USD',
                    'METIS/USD',
                    'MOVR/USD',
                    'NEAR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'QUICK/USD',
                    'ROSE/USD',
                    'RPL/USD',
                    'RSR/USD',
                    'RUNE/USD',
                    'SAND/USD',
                    'SHIB/USD',
                    'SNX/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'STG/USD',
                    'STX/USD',
                    'SUSHI/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XLM/USD',
                    'XRP/USD',
                    'XTZ/USD',
                    'YFI/USD',
                    'ZIL/USD',
                    'ZRX/USD',
                    'MASK/USD',
                    'ENS/USD',
                    'BLUR/USD',
                    'BAND/USD',
                    'UMA/USD',
                    'APT/USD',
                    'OSMO/USD',
                    'SUI/USD',
                    'GNS/USD',
                    'FRAX/USD',
                    'crvUSD/USD',
                    'LUSD/USD',
                    'GHO/USD',
                    'MNT/USD',
                    'ASTR/USD',
                    'KAVA/USD',
                    'PYTH/USD',
                    'RDNT/USD',
                    'RIF/USD',
                    'WOO/USD',
                    'TIA/USD',
                    'DYM/USD',
                    'USDe/USD',
                    'EURe/USD',
                    'SEI/USD',
                    'AR/USD',
                    'STRK/USD',
                    'AXL/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'RON/USD',
                    'XVS/USD',
                    'PENDLE/USD',
                    'TWT/USD',
                    'AERO/USD',
                    'TAO/USD',
                    'PYUSD/USD',
                    'MERL/USD',
                    'ORDI/USD',
                    'SATS/USD',
                    'NEON/USD',
                    'INJ/USD',
                    'RARI/USD',
                    'MODE/USD',
                    'CORE/USD',
                    'DEGEN/USD',
                    'ENA/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'ETHFI/USD',
                    'SAFE/USD',
                    'TAIKO/USD',
                    'W/USD',
                    'BLAST/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'CFX/USD',
                    'RENDER/USD',
                    'POL/USD',
                    'EURC/USD',
                    'FBTC/USD',
                    'AUSD/USD',
                    'LUMIA/USD',
                    'BRETT/USD',
                    'cbBTC/USD',
                    'COOK/USD',
                    'SCR/USD',
                    'SolvBTC/USD',
                    'ZRC/USD',
                    'MORPHO/USD',
                    'LBTC/USD',
                    'S/USD',
                    'VELO/USD',
                    'MTL/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'frxUSD/USD',
                    'HYPE/USD',
                    'VET/USD',
                    'tBTC/USD',
                    'VTHO/USD',
                    'MVL/USD',
                    'VIRTUAL/USD',
                    'DOLA/USD',
                    'SPK/USD',
                    'SYRUP/USD',
                    'RESOLV/USD',
                    'XAUt/USD',
                    'USD1/USD'
                ]
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'us-east-2', provider: 'aws' },
            { signedApi: false, region: 'eu-west-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.coingecko.com',
        verifiedBaseUrl: 'https://www.coingecko.com',
        signedApiUrl: 'https://signed-api.coingecko.com',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'coindesk-mock': {
        alias: 'coindesk-mock',
        name: 'CoinDesk-Mock',
        providerType: 'rest',
        airnode: '0x62D1E697949CB9D931C545A19868Bd8009c9def9',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            CoinDesk: [
                [
                    'AAVE/USD',
                    'ADA/USD',
                    'ALGO/USD',
                    'ANKR/USD',
                    'APE/USD',
                    'API3/USD',
                    'ARB/USD',
                    'ATOM/USD',
                    'AVAX/USD',
                    'AXS/USD',
                    'BAL/USD',
                    'BAT/USD',
                    'BNB/USD',
                    'BTC/USD',
                    'CAKE/USD',
                    'CELO/USD',
                    'CHZ/USD',
                    'COMP/USD',
                    'CRO/USD',
                    'CRV/USD',
                    'CVX/USD',
                    'DAI/USD',
                    'DOGE/USD',
                    'DOT/USD',
                    'DYDX/USD',
                    'ETH/USD',
                    'FIL/USD',
                    'FLOW/USD',
                    'FXS/USD',
                    'GLMR/USD',
                    'GMX/USD',
                    'GNO/USD',
                    'GRT/USD',
                    'HBAR/USD',
                    'HNT/USD',
                    'ICP/USD',
                    'IMX/USD',
                    'JOE/USD',
                    'KDA/USD',
                    'KSM/USD',
                    'LDO/USD',
                    'LINK/USD',
                    'LQTY/USD',
                    'LTC/USD',
                    'MANA/USD'
                ],
                [
                    'MKR/USD',
                    'METIS/USD',
                    'MOVR/USD',
                    'NEAR/USD',
                    'OKB/USD',
                    'OP/USD',
                    'PAXG/USD',
                    'QUICK/USD',
                    'ROSE/USD',
                    'RPL/USD',
                    'RSR/USD',
                    'RUNE/USD',
                    'SAND/USD',
                    'SHIB/USD',
                    'SNX/USD',
                    'SOL/USD',
                    'stETH/USD',
                    'STG/USD',
                    'STX/USD',
                    'SUSHI/USD',
                    'TUSD/USD',
                    'UNI/USD',
                    'USDT/USD',
                    'USDC/USD',
                    'USDP/USD',
                    'WBTC/USD',
                    'XLM/USD',
                    'XRP/USD',
                    'XTZ/USD',
                    'YFI/USD',
                    'ZIL/USD',
                    'ZRX/USD',
                    'MASK/USD',
                    'ENS/USD',
                    'BLUR/USD',
                    'BAND/USD',
                    'UMA/USD',
                    'APT/USD',
                    'OSMO/USD',
                    'SUI/USD',
                    'GNS/USD',
                    'KAVA/USD',
                    'RDNT/USD',
                    'RIF/USD',
                    'GHO/USD'
                ],
                [
                    'crvUSD/USD',
                    'EURe/USD',
                    'FRAX/USD',
                    'LUSD/USD',
                    'WOO/USD',
                    'PYTH/USD',
                    'USDe/USD',
                    'ASTR/USD',
                    'TIA/USD',
                    'DYM/USD',
                    'SEI/USD',
                    'AR/USD',
                    'STRK/USD',
                    'AXL/USD',
                    'ONDO/USD',
                    'MANTA/USD',
                    'XVS/USD',
                    'PENDLE/USD',
                    'TWT/USD',
                    'AERO/USD',
                    'TAO/USD',
                    'PYUSD/USD',
                    'MERL/USD',
                    'ORDI/USD',
                    'SATS/USD',
                    'INJ/USD',
                    'MODE/USD',
                    'NEON/USD',
                    'RARI/USD',
                    'CORE/USD',
                    'DEGEN/USD',
                    'ENA/USD',
                    'FDUSD/USD',
                    'WLD/USD',
                    'EURC/USD',
                    'ZRO/USD',
                    'ZK/USD',
                    'ETHFI/USD',
                    'SAFE/USD',
                    'TAIKO/USD',
                    'W/USD',
                    'BLAST/USD',
                    'CFX/USD',
                    'RENDER/USD',
                    'POL/USD'
                ],
                [
                    'AUSD/USD',
                    'LUMIA/USD',
                    'COOK/USD',
                    'cbBTC/USD',
                    'BRETT/USD',
                    'MORPHO/USD',
                    'ZRC/USD',
                    'LBTC/USD',
                    'S/USD',
                    'VELO/USD',
                    'MTL/USD',
                    'BERA/USD',
                    'USDS/USD',
                    'HYPE/USD',
                    'VET/USD',
                    'tBTC/USD',
                    'VTHO/USD',
                    'MVL/USD',
                    'VIRTUAL/USD',
                    'SYRUP/USD',
                    'RESOLV/USD',
                    'XAUt/USD',
                    'MNT/USD',
                    'RON/USD',
                    'SCR/USD'
                ]
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    'blocksize-mock': {
        alias: 'blocksize-mock',
        name: 'BLOCKSIZE-Mock',
        providerType: 'rest',
        airnode: '0x3E377AcDc90AD2912E92B5031aAE4BBFb3670b95',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            Blocksize: [
                ['AAVE/USD'],
                ['AERO/USD'],
                ['ADA/USD'],
                ['ALGO/USD'],
                ['ANKR/USD'],
                ['APE/USD'],
                ['API3/USD'],
                ['APT/USD'],
                ['AR/USD'],
                ['ARB/USD'],
                ['ASTR/USD'],
                ['ATOM/USD'],
                ['AVAX/USD'],
                ['AXL/USD'],
                ['AXS/USD'],
                ['BAL/USD'],
                ['BAND/USD'],
                ['BAT/USD'],
                ['BLAST/USD'],
                ['BLUR/USD'],
                ['BNB/USD'],
                ['BTC/USD'],
                ['CAKE/USD'],
                ['CELO/USD'],
                ['CHZ/USD'],
                ['CORE/USD'],
                ['COMP/USD'],
                ['CRO/USD'],
                ['CRV/USD'],
                ['CVX/USD'],
                ['DOGE/USD'],
                ['DOT/USD'],
                ['DYDX/USD'],
                ['ENA/USD'],
                ['ENS/USD'],
                ['ETH/USD'],
                ['ETHFI/USD'],
                ['FIL/USD'],
                ['FLOW/USD'],
                ['FXS/USD'],
                ['GLMR/USD'],
                ['GMX/USD'],
                ['GNO/USD'],
                ['GNS/USD'],
                ['GRT/USD'],
                ['HBAR/USD'],
                ['HNT/USD'],
                ['ICP/USD'],
                ['IMX/USD'],
                ['INJ/USD'],
                ['JOE/USD'],
                ['KAVA/USD'],
                ['KDA/USD'],
                ['KSM/USD'],
                ['LDO/USD'],
                ['LINK/USD'],
                ['LQTY/USD'],
                ['LTC/USD'],
                ['MANA/USD'],
                ['MANTA/USD'],
                ['MASK/USD'],
                ['MERL/USD'],
                ['METIS/USD'],
                ['MKR/USD'],
                ['MNT/USD'],
                ['MODE/USD'],
                ['MOVR/USD'],
                ['NEAR/USD'],
                ['NEON/USD'],
                ['OKB/USD'],
                ['ORDI/USD'],
                ['OP/USD'],
                ['OSMO/USD'],
                ['PAXG/USD'],
                ['QUICK/USD'],
                ['RARI/USD'],
                ['RDNT/USD'],
                ['RIF/USD'],
                ['RON/USD'],
                ['ROSE/USD'],
                ['RPL/USD'],
                ['RSR/USD'],
                ['RUNE/USD'],
                ['SAND/USD'],
                ['SATS/USD'],
                ['SHIB/USD'],
                ['SNX/USD'],
                ['SOL/USD'],
                ['stETH/USD'],
                ['STRK/USD'],
                ['STG/USD'],
                ['STX/USD'],
                ['SUI/USD'],
                ['SUSHI/USD'],
                ['TAIKO/USD'],
                ['TAO/USD'],
                ['TWT/USD'],
                ['UMA/USD'],
                ['UNI/USD'],
                ['W/USD'],
                ['WBTC/USD'],
                ['WOO/USD'],
                ['XLM/USD'],
                ['XRP/USD'],
                ['XVS/USD'],
                ['XTZ/USD'],
                ['YFI/USD'],
                ['ZIL/USD'],
                ['ZRX/USD'],
                ['TIA/USD'],
                ['DEGEN/USD'],
                ['DYM/USD'],
                ['SAFE/USD'],
                ['WLD/USD'],
                ['PYTH/USD'],
                ['PENDLE/USD'],
                ['SEI/USD'],
                ['ONDO/USD'],
                ['DAI/USD'],
                ['POL/USD'],
                ['RENDER/USD'],
                ['TUSD/USD'],
                ['USDC/USD'],
                ['USDP/USD'],
                ['USDT/USD'],
                ['GHO/USD'],
                ['crvUSD/USD'],
                ['CFX/USD'],
                ['LUSD/USD'],
                ['FRAX/USD'],
                ['AUSD/USD'],
                ['EURC/USD'],
                ['USDe/USD'],
                ['FBTC/USD'],
                ['SCR/USD'],
                ['COOK/USD'],
                ['cbBTC/USD'],
                ['BRETT/USD'],
                ['LUMIA/USD'],
                ['SolvBTC/USD'],
                ['ZRC/USD'],
                ['MORPHO/USD'],
                ['LBTC/USD'],
                ['S/USD'],
                ['VELO/USD'],
                ['MTL/USD'],
                ['BERA/USD'],
                ['USDS/USD'],
                ['EURe/USD'],
                ['ZK/USD'],
                ['ZRO/USD'],
                ['frxUSD/USD'],
                ['HYPE/USD'],
                ['VET/USD'],
                ['tBTC/USD'],
                ['VTHO/USD'],
                ['MVL/USD'],
                ['VIRTUAL/USD'],
                ['DOLA/USD'],
                ['SPK/USD'],
                ['SYRUP/USD'],
                ['RESOLV/USD'],
                ['XAUt/USD'],
                ['USD1/USD'],
                ['sUSDS/USD'],
                ['USDtb/USD'],
                ['syrupUSDC/USD'],
                ['USDX/USD'],
                ['USDY/USD'],
                ['USD0/USD'],
                ['USDf/USD'],
                ['RLUSD/USD'],
                ['USDD/USD'],
                ['USDG/USD'],
                ['BUSD/USD'],
                ['USDO/USD'],
                ['USR/USD'],
                ['USDa/USD'],
                ['EUR/USD'],
                ['WELL/USD']
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    blocksize: {
        alias: 'blocksize',
        name: 'BLOCKSIZE',
        providerType: 'rest',
        airnode: '0xabfbeE00151A4Dc99548341F2e3e75f7abB37B61',
        previousAirnodes: [{ expiryTimestamp: 1749628891, airnodeAddress: '0x1Fb13E33B505d359b734F02A95E392284A205895' }],
        xpub: 'xpub6DFZFbJ2UStN4rqyTAvTUV97XLsvFQPiM54HDU2hhn4QLxUFHTtjKRfKVswzxecCmqWjxtmXTjGJUXFNRwore8eW6tzCRFuSJD3HVj4WeLr',
        supportedFeedsInBatches: {
            Blocksize: [
                ['AAVE/USD'],
                ['AERO/USD'],
                ['ADA/USD'],
                ['ALGO/USD'],
                ['ANKR/USD'],
                ['APE/USD'],
                ['API3/USD'],
                ['APT/USD'],
                ['AR/USD'],
                ['ARB/USD'],
                ['ASTR/USD'],
                ['ATOM/USD'],
                ['AVAX/USD'],
                ['AXL/USD'],
                ['AXS/USD'],
                ['BAL/USD'],
                ['BAND/USD'],
                ['BAT/USD'],
                ['BLAST/USD'],
                ['BLUR/USD'],
                ['BNB/USD'],
                ['BTC/USD'],
                ['CAKE/USD'],
                ['CELO/USD'],
                ['CHZ/USD'],
                ['CORE/USD'],
                ['COMP/USD'],
                ['CRO/USD'],
                ['CRV/USD'],
                ['CVX/USD'],
                ['DOGE/USD'],
                ['DOT/USD'],
                ['DYDX/USD'],
                ['ENA/USD'],
                ['ENS/USD'],
                ['ETH/USD'],
                ['ETHFI/USD'],
                ['FIL/USD'],
                ['FLOW/USD'],
                ['FXS/USD'],
                ['GLMR/USD'],
                ['GMX/USD'],
                ['GNO/USD'],
                ['GNS/USD'],
                ['GRT/USD'],
                ['HBAR/USD'],
                ['HNT/USD'],
                ['ICP/USD'],
                ['IMX/USD'],
                ['INJ/USD'],
                ['JOE/USD'],
                ['KAVA/USD'],
                ['KDA/USD'],
                ['KSM/USD'],
                ['LDO/USD'],
                ['LINK/USD'],
                ['LQTY/USD'],
                ['LTC/USD'],
                ['MANA/USD'],
                ['MANTA/USD'],
                ['MASK/USD'],
                ['MERL/USD'],
                ['METIS/USD'],
                ['MKR/USD'],
                ['MNT/USD'],
                ['MODE/USD'],
                ['MOVR/USD'],
                ['NEAR/USD'],
                ['NEON/USD'],
                ['OKB/USD'],
                ['ORDI/USD'],
                ['OP/USD'],
                ['OSMO/USD'],
                ['PAXG/USD'],
                ['QUICK/USD'],
                ['RARI/USD'],
                ['RDNT/USD'],
                ['RIF/USD'],
                ['RON/USD'],
                ['ROSE/USD'],
                ['RPL/USD'],
                ['RSR/USD'],
                ['RUNE/USD'],
                ['SAND/USD'],
                ['SATS/USD'],
                ['SHIB/USD'],
                ['SNX/USD'],
                ['SOL/USD'],
                ['stETH/USD'],
                ['STRK/USD'],
                ['STG/USD'],
                ['STX/USD'],
                ['SUI/USD'],
                ['SUSHI/USD'],
                ['TAIKO/USD'],
                ['TAO/USD'],
                ['TWT/USD'],
                ['UMA/USD'],
                ['UNI/USD'],
                ['W/USD'],
                ['WBTC/USD'],
                ['WOO/USD'],
                ['XLM/USD'],
                ['XRP/USD'],
                ['XVS/USD'],
                ['XTZ/USD'],
                ['YFI/USD'],
                ['ZIL/USD'],
                ['ZRX/USD'],
                ['TIA/USD'],
                ['DEGEN/USD'],
                ['DYM/USD'],
                ['SAFE/USD'],
                ['WLD/USD'],
                ['PYTH/USD'],
                ['PENDLE/USD'],
                ['SEI/USD'],
                ['ONDO/USD'],
                ['DAI/USD'],
                ['POL/USD'],
                ['RENDER/USD'],
                ['TUSD/USD'],
                ['USDC/USD'],
                ['USDP/USD'],
                ['USDT/USD'],
                ['GHO/USD'],
                ['crvUSD/USD'],
                ['CFX/USD'],
                ['LUSD/USD'],
                ['FRAX/USD'],
                ['AUSD/USD'],
                ['EURC/USD'],
                ['USDe/USD'],
                ['FBTC/USD'],
                ['SCR/USD'],
                ['COOK/USD'],
                ['cbBTC/USD'],
                ['BRETT/USD'],
                ['LUMIA/USD'],
                ['SolvBTC/USD'],
                ['ZRC/USD'],
                ['MORPHO/USD'],
                ['LBTC/USD'],
                ['S/USD'],
                ['VELO/USD'],
                ['MTL/USD'],
                ['BERA/USD'],
                ['USDS/USD'],
                ['EURe/USD'],
                ['ZK/USD'],
                ['ZRO/USD'],
                ['frxUSD/USD'],
                ['HYPE/USD'],
                ['VET/USD'],
                ['tBTC/USD'],
                ['VTHO/USD'],
                ['MVL/USD'],
                ['VIRTUAL/USD'],
                ['DOLA/USD'],
                ['SPK/USD'],
                ['SYRUP/USD'],
                ['RESOLV/USD'],
                ['XAUt/USD'],
                ['USD1/USD']
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'eu-central-1', provider: 'aws' },
            { signedApi: false, region: 'us-east-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.blocksize.info',
        verifiedBaseUrl: 'https://blocksize.info',
        signedApiUrl: 'https://signed-api.blocksize.info',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'ankr-mock': {
        alias: 'ankr-mock',
        name: 'Ankr-Mock',
        providerType: 'rpc',
        airnode: '0x2eBAe534e166b3D940a53511aD479C3e1de2A1af',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            Ankr: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'ETHx/ETH Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'weETHs/ETH Exchange Rate',
                    'inETH/ETH Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'ultraETHs/wstETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'instETH/stETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'insfrxETH/sfrxETH Exchange Rate',
                    'egETH/ETH Exchange Rate',
                    'mstETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'inwstETHs/wstETH Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['USDY/USD Exchange Rate'],
                ['wOS/OS Exchange Rate']
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    ankr: {
        alias: 'ankr',
        name: 'Ankr',
        providerType: 'rpc',
        airnode: '0xAaA5fdF8189C6344bA17De6C1a877beb416990AC',
        previousAirnodes: [],
        xpub: 'xpub6CXN3cVGEXfshsprcmzbmSYt2zrcsjuZEEGABTaPuV9b47Emxpo4bgyGrLpiKw6hrArTXgPqV6xjZvLTEP8z6VU9UNsLBjNsfEaZ9U6aDjy',
        supportedFeedsInBatches: {
            Ankr: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'ETHx/ETH Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'weETHs/ETH Exchange Rate',
                    'inETH/ETH Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'ultraETHs/wstETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'instETH/stETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'insfrxETH/sfrxETH Exchange Rate',
                    'egETH/ETH Exchange Rate',
                    'mstETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'inwstETHs/wstETH Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['USDY/USD Exchange Rate']
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'us-east-1', provider: 'aws' },
            { signedApi: false, region: 'eu-central-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.ankr.com',
        verifiedBaseUrl: 'ankr.com',
        signedApiUrl: 'https://signed-api.ankr.com',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    },
    'alchemy-mock': {
        alias: 'alchemy-mock',
        name: 'Alchemy-Mock',
        providerType: 'rpc',
        airnode: '0x5B2a49765b8E5820E3642c2C21a997A7D02BbcAC',
        previousAirnodes: [],
        xpub: '',
        supportedFeedsInBatches: {
            Alchemy: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'ETHx/ETH Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'weETHs/ETH Exchange Rate',
                    'inETH/ETH Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'ultraETHs/wstETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'instETH/stETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'insfrxETH/sfrxETH Exchange Rate',
                    'egETH/ETH Exchange Rate',
                    'mstETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'inwstETHs/wstETH Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['USDY/USD Exchange Rate'],
                ['wOS/OS Exchange Rate']
            ]
        },
        deploymentConfigurations: [{ signedApi: false, region: '', provider: 'local' }],
        homepageUrl: '',
        verifiedBaseUrl: '',
        signedApiUrl: '',
        productionSignedApiUrls: [],
        stagingSignedApiUrl: { url: 'https://signed-api.nodary.io', name: 'Nodary' }
    },
    alchemy: {
        alias: 'alchemy',
        name: 'Alchemy',
        providerType: 'rpc',
        airnode: '0x886AD79b463B1BCa97C0fbF4D5e9782542e5EE40',
        previousAirnodes: [],
        xpub: 'xpub6CV7uveoXskcGCdMyzK7YNYUDY3NEsRtT6WRKR7Va92h9uadwUY3zhqj24EmtvPiqVYWtcg7jG8Eur9bQFWSikTqrzEWPGGmXTQ12oDm2Gb',
        supportedFeedsInBatches: {
            Alchemy: [
                [
                    'cbETH/ETH Exchange Rate',
                    'rETH/ETH Exchange Rate',
                    'sfrxETH/frxETH Exchange Rate',
                    'swETH/ETH Exchange Rate',
                    'wstETH/stETH Exchange Rate',
                    'mETH/ETH Exchange Rate',
                    'MATICx/MATIC Exchange Rate',
                    'ETHx/ETH Exchange Rate',
                    'uniETH/ETH Exchange Rate',
                    'weETH/ETH Exchange Rate',
                    'STONE/ETH Exchange Rate',
                    'rsETH/ETH Exchange Rate',
                    'rswETH/ETH Exchange Rate',
                    'apxETH/pxETH Exchange Rate',
                    'ezETH/ETH Exchange Rate',
                    'sDAI/DAI Exchange Rate',
                    'sUSDe/USDe Exchange Rate',
                    'pufETH/stETH Exchange Rate',
                    'stTAO/TAO Exchange Rate',
                    'sFRAX/FRAX Exchange Rate',
                    'weETHs/ETH Exchange Rate',
                    'inETH/ETH Exchange Rate',
                    'ankrETH/ETH Exchange Rate',
                    'ultraETHs/wstETH Exchange Rate',
                    'agETH/rsETH Exchange Rate',
                    'instETH/stETH Exchange Rate',
                    'eBTC/WBTC Exchange Rate',
                    'cmETH/mETH Exchange Rate',
                    'LsETH/ETH Exchange Rate',
                    'insfrxETH/sfrxETH Exchange Rate',
                    'egETH/ETH Exchange Rate',
                    'mstETH/ETH Exchange Rate',
                    'yUSD/USD Exchange Rate',
                    'inwstETHs/wstETH Exchange Rate',
                    'scrvUSD/crvUSD Exchange Rate',
                    'sUSDS/USDS Exchange Rate',
                    'ysUSDC/USDC Exchange Rate',
                    'sfrxUSD/frxUSD Exchange Rate',
                    'osETH/ETH Exchange Rate'
                ],
                ['wBETH/ETH Exchange Rate', 'slisBNB/BNB Exchange Rate', 'BNBx/BNB Exchange Rate'],
                ['sAVAX/AVAX Exchange Rate'],
                ['USDY/USD Exchange Rate']
            ]
        },
        deploymentConfigurations: [
            { signedApi: true, region: 'eu-central-1', provider: 'aws' },
            { signedApi: false, region: 'us-east-1', provider: 'aws' }
        ],
        homepageUrl: 'https://www.alchemy.com',
        verifiedBaseUrl: 'https://alchemy.com',
        signedApiUrl: 'https://signed-api.alchemy.com',
        productionSignedApiUrls: [
            { url: 'https://signed-api.nodary.io', name: 'Nodary' },
            { url: 'https://signed-api.api3.org', name: 'API3' },
            { url: 'http://signed-api.self.internal', name: 'Self' }
        ],
        stagingSignedApiUrl: { url: 'https://signed-api.stage.nodary.io', name: 'Staging' }
    }
};
exports.airnodeAddressMap = {
    'shiftmarkets-mock': '0x4C283936141b6AD8253C599091f86DAdE9dd8fDc',
    shiftmarkets: '0x11A49f063c08f9C9d7A6b13E0529dC132Bd09fF5',
    'nodary-mock': '0x241364bbd08701330bdc810bAaA10cF8DF1710E5',
    nodary: '0xc52EeA00154B4fF1EbbF8Ba39FDe37F1AC3B9Fd4',
    'ncfx-mock': '0x220Ad4917B349F69288E892e50E929A693B71920',
    ncfx: '0xbC6471E88d8aFe936A45bEB8bd20a210EBEF6822',
    'infura-mock': '0x4D81964F58409651eF5C191166a9Ff6e6b40986f',
    infura: '0x72bFf91fc62E03f917D5c1202225f92f74cBe67e',
    'finage-mock': '0xD7AD63b84F03FF923a690bAE32C988097C70C673',
    finage: '0xa924847354c551C79BAE7E75529364bA0449e51A',
    'dxfeed-mock': '0xC479695045E1730bDE7697c6eD9442cB4A6Da6a0',
    dxfeed: '0x9E3F8344DB06aDFFD1E9C5D6A65b33aFbC321610',
    'drpc-mock': '0xDFCC177437f9Be5e5A0828A620664A4C1321e780',
    drpc: '0x14F4bC1EC875f4A8d260721B0A7b07262A71a220',
    'coinpaprika-mock': '0x59493508C6CdE2179100CE2994919Dae38D893b2',
    coinpaprika: '0xC9B494D3c6eA3fD42779Df9A136Db10374c98D80',
    'coingecko-mock': '0x887cA5E7D4d6CcE427949561CD149983F39c9F02',
    coingecko: '0x6b56E47DccFbC82D63Df3da417d26e8B1B877f0f',
    'coindesk-mock': '0x62D1E697949CB9D931C545A19868Bd8009c9def9',
    'blocksize-mock': '0x3E377AcDc90AD2912E92B5031aAE4BBFb3670b95',
    blocksize: '0xabfbeE00151A4Dc99548341F2e3e75f7abB37B61',
    'ankr-mock': '0x2eBAe534e166b3D940a53511aD479C3e1de2A1af',
    ankr: '0xAaA5fdF8189C6344bA17De6C1a877beb416990AC',
    'alchemy-mock': '0x5B2a49765b8E5820E3642c2C21a997A7D02BbcAC',
    alchemy: '0x886AD79b463B1BCa97C0fbF4D5e9782542e5EE40'
};
//# sourceMappingURL=apis.js.map